"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  system: {
    user: {
      bView: '觀看',
      bEdit: '修改',
      bDelete: '刪除',
      bBind: '綁定谷歌碼',
      userManagement: "用戶管理",
      username: "用戶名",
      status: "狀態",
      query: "查詢",
      add: "新增",
      delete: "刪除",
      resetPassword: "密碼重置",
      unauthorized: "無權限",
      optionTip: "請選擇",
      optionDisable: "禁用",
      optionValid: "有效",
      inputPlaceholder: "請選擇",
      placeholder: "查詢用戶名",
      statusPlaceholder: "查詢狀態",
      table: {
        username: "用戶名",
        sex: "性別",
        department: "部門",
        mobile: "手機",
        email: "郵箱",
        userStatus: "狀態",
        loginFaildCount: "登錄失敗次數",
        createTime: "創建時間",
        operation: "操作",
        detail: {
          userInfo: "用戶信息"
        },
        del: {
          deletedUser: "刪除用戶",
          confirmDelete: "確定刪除該用戶?"
        },
        edit: {
          updateUser: "修改用戶",
          submit: "提交",
          cancel: "取消"
        },
        google: {
          bindCode: "綁定谷歌碼",
          confirm: "確定",
          cancel: "取消"
        }
      },
      userTable: {
        newUsers: "新增用戶",
        submit: "提交",
        reset: "重置",
        deleteWarn: "請選擇需要刪除的用戶",
        deletedUser: "刪除用戶",
        confirmDelete: "確定刪除該用戶?",
        resetWarn: "請選擇需要重置密碼的用戶",
        resetSuccess: "所選用戶密碼已重置為",
        resetSuccessInfo: '，請在第一次登入後修改！'
      },
      treeSelect: {
        placeholder: "請選擇"
      },
      deleteUsers: {
        warn: "所選用戶包含當前登錄用戶，無法刪除",
        success: "刪除用戶成功"
      }
    },
    userAdd: {
      username: "用戶名",
      mobile: "手機",
      email: "郵箱",
      role: "角色",
      department: "部門",
      status: "狀態",
      statusInput: {
        valid: "有效",
        disable: "禁用"
      },
      gender: "性別",
      sexInput: {
        male: "男性",
        female: "女性",
        secret: "保密"
      },
      remark: "備註",
      treeSelect: {
        placeholder: "請選擇"
      },
      formSelects: {
        error: "獲取角色列表失敗"
      },
      userAddFormSubmit: {
        success: "新增用戶成功，初始密碼為 1234Qwer"
      }
    },
    role: {
      viewRole: "角色信息",
      layTitle: "角色管理",
      roleName: "角色名稱",
      query: "查詢",
      createRole: "新增角色",
      roleID: "角色ID",
      roleNameHeader: "角色名稱",
      roleDescription: "角色描述",
      rolePermission: "角色權限",
      submitButton: "保存",
      noPermission: "無權限",
      addRoleButton: "新增",
      deleteRoleButton: "刪除",
      deleteRoleText1: "請選擇需要刪除的角色",
      deleteRoleText2: "刪除角色",
      deleteRoleText3: "確定刪除所選角色？",
      deleteRoleText4: "刪除角色成功",
      editRoleText1: "修改角色",
      editRoleText2: "修改角色成功",
      createRoleText1: "新增角色成功",
      hintsText: "提示",
      noPermissionConfirmText: "當前角色未授予任何權限，是否繼續？",
      createTimeText: "創建時間",
      operationText: "操作",
      placeholder: "查詢角色名稱"
    },
    menu: {
      menuManagement: "菜單管理",
      nameHeader: "名稱",
      queryText: "查詢",
      addMenu: "新增菜單",
      parentMenuID: "上級ID",
      menuName: "名稱",
      menuType: "類型",
      menuType1: "菜單",
      menuType2: "按鈕",
      menuIcon: "圖標",
      menuPermission: "權限",
      menuListOrder: "排序",
      submitButton: "保存",
      warningText1: "只能選擇一個節點作為父級！",
      warningText2: "不能選擇按鈕作為父級！",
      warningText3: "請勾選需要刪除的菜單或按鈕",
      warningText4: "數據未作任何修改！",
      hintsText: "提示",
      deleteConfirmText: "當您點擊確定按鈕後，這些記錄將會被徹底刪除，如果其包含子記錄，也將一並刪除！",
      deleteSuccessText: "刪除成功！",
      menuInformationExcel: "菜單信息表.xlsx",
      addText: "新增",
      deleteText: "刪除",
      exportExcelText: "導出Excel",
      editMenuText: "修改菜單",
      editButtonText: "修改按鈕",
      selectIconText: "圖標選擇",
      confirmText: "確定",
      addButtonText: "新增按鈕",
      editText: "修改",
      editSuccessText: "修改成功",
      addSuccessText: "新增成功",
      placeholder: "查詢菜單"
    },
    dept: {
      department: "部門",
      layTitle: "部門管理",
      name: "名稱",
      query: "查詢",
      formHeader: "新增部門",
      parentDepartmentID: "上級ID:",
      departmentName: "部門名稱：",
      departmentSort: "部門排序：",
      submit: "保存",
      eleTreeHeaderText: "修改部門",
      dropdownAddWarnText: "只能選擇一個節點作為父級！",
      dropdownDeleteWarnText: "請勾選需要刪除的部門",
      dropdownDeletePromptText: "提示",
      dropdownDeleteInfoText: "當您點擊確定按鈕後，這些記錄將會被徹底刪除，如果其包含子記錄，也將一並刪除！",
      dropdownDeleteSuccessText: "刪除成功！",
      dropdownExportText: "部門信息表.xlsx",
      optionAdd: "新增部門",
      optionDelete: "刪除部門",
      optionExport: "導出Excel",
      resetText: "新增部門",
      formSubmitEditText: "修改",
      formSubmitWarnText: "數據未作任何修改!",
      formSubmitEditSuccessText: "修改成功",
      formSubmitAddSuccessText: "新增成功",
      placeholder: "查詢部門",
      deptName: "部門名稱"
    },
    codeSortUpdate: {
      dictionaryCategoryId: "字典分類id",
      categoryName: "分類名稱",
      categoryCode: "分類代碼",
      parentCode: "上級代碼",
      description: "描述",
      remark: "備註",
      dateCreated: "創建時間",
      operationText: "操作",
      updateFormWarnText: "數據未作任何修改！",
      updateFormSuccessText: "數據修改成功"
    },
    codeSortAdd: {
      categoryName: "分類名稱",
      categoryCode: "分類代碼",
      parentCode: "上級代碼",
      description: "描述",
      remark: "備註",
      addFormSuccessText: "新增字典分類成功"
    },
    codeSort: {
      layTitle: "字典分類",
      categoryName: "分類名稱",
      query: "查詢",
      tableAddOpenText: "新增字典分類",
      tableAddBtnConfirmText: "提交",
      tableAddBtnResetText: "重置",
      toolBarDeleteWarnText: "請選擇需要刪除的字典分類",
      toolBarDeleteConfirmTex: "刪除字典分類",
      toolBarDeleteConfirmInformation: "確定刪除該字典分類?",
      toolDelConfirmText: "刪除字典分類",
      toolDelConfirmInformation: "確定刪除該字典分類?",
      toolEditOpenText: "修改字典分類",
      toolEditBtnConfirmText: "提交",
      toolEditBtnResetText: "取消",
      iniTableCodeTitle: "代碼",
      iniTableNameTitle: "名稱",
      iniTableRemarkTitle: "備註",
      iniTableCreateTimeTitle: "創建時間",
      iniTableOperationTitle: "操作",
      deleteCodeSortsSuccessText: "刪除字典分類成功",
      placeholder: "查詢字典分類名稱",
      categoryCode: "分類代碼"
    },
    code: {
      layTitle: "字典管理",
      parentCode: "上級代碼",
      code: "代碼",
      codeName: "代碼名稱",
      query: "查詢",
      toolBarAddOpenText: "新增字典",
      toolBarAddBtnSubmitText: " 提交",
      toolBarAddBtnResetText: "重置",
      toolBarDeleteWarnText: "請選擇需要刪除的字典",
      toolBarDeleteConfirmText: "刪除字典",
      toolBarDeleteConfirmInformation: "確定刪除該字典?",
      toolBarLoadReapplicationConfirmText: "確定刷新緩存",
      toolBarLoadReapplicationConfirmInformation: "確定刷新緩存?",
      toolBarLoadReapplicationSuccessText: "刷新緩存成功",
      toolBarGatewayLoadConfigCacheConfirmText: "確定刷新緩存",
      toolBarGatewayLoadConfigCacheConfirmInformation: "確定刷新所有網關服務器的緩存?",
      toolBarGatewayLoadConfigCacheSuccessText: "刷新網關服務器緩存成功",
      toolBarMerchLoadConfigCacheConfirmText: "確定刷新緩存",
      toolBarMerchLoadConfigCacheConfirmInformation: "確定刷新所有企業端服務器的緩存?",
      toolBarMerchLoadConfigCacheSuccessText: "刷新企業服務器緩存成功",
      toolBarAgentLoadConfigCacheConfirmText: "確定刷新緩存",
      toolBarAgentLoadConfigCacheConfirmInformation: "確定刷新所有代理端服務器的緩存?",
      toolBarAgentLoadConfigCacheSuccessText: "刷新代理服務器緩存成功",
      codeTableDelConfirmText: "刪除字典",
      codeTableDelConfirmInformation: "確定刪除該字典?",
      codeTableEditOpenText: "修改字典",
      codeTableEditBtnSubmitText: "提交",
      codeTableEditBtnCancelText: "取消",
      initTableSortCodeTitle: "字典分類",
      initTableCodeTitle: "代碼",
      initTableNameTitle: "字典名稱",
      initTableParentCodeTitle: "上級代碼",
      initTableDescriptionTitle: "描述",
      initTableRemarkTitle: "備註",
      initTableCreateTimeTitle: "創建時間",
      initTableOperationTitle: "操作",
      deleteCodeSuccess: "刪除字典成功",
      placeholder: "查詢關鍵詞",
      cache: "刷新緩存",
      gatewayCache: "刷新網關緩存",
      organizationCache: "刷新企業端緩存",
      organizationSendCache: "刷新企業發送端緩存",
      proxyCache: "刷新代理端緩存",
      cacheRefreshed: '緩存已刷新',
      agentCacheRefreshed: '代理緩存指令已發送',
      merchantCacheRefreshed: '企業緩存指令已發送',
      gatewayCacheRefreshed: '網關緩存指令已發送',
      dictionaryName: "字典名稱",
      dictionaryCategory: "字典分類"
    },
    codeAdd: {
      dictionaryName: "字典名稱:",
      code: "代碼: ",
      parentCode: "上級代碼:",
      dictionaryCategory: "字典分類:",
      description: "描述:",
      remark: "備註:",
      formSelectsErrorText: "獲取字典分類列表失敗",
      codeAddFormSuccessText: "新增字典成功"
    },
    codeUpdate: {
      dictionaryI: "字典id:",
      dictionaryName: "字典名稱:",
      code: "代碼: ",
      parentCode: "上級代碼:",
      dictionaryCategory: "字典分類:",
      description: "描述:",
      remark: "備註:",
      formSelectsErrorText: "獲取字典分類列表失敗",
      codeUpdateFormWarnText: "數據未作任何修改",
      codeUpdateFormSuccessText: "數據修改成功"
    },
    areaNumber: {
      layTitle: "地區號碼",
      areaName: "地區名稱",
      query: "查詢",
      toolbarAreaNumberTableAddOpenText: "新增地區號碼",
      toolbarAreaNumberTableAddBtnSubmitText: "提交",
      toolbarAreaNumberTableAddBtnResetText: "重置",
      toolbarAreaNumberTableDeleteWarnText: "請選擇需要刪除的地區號碼",
      toolbarAreaNumberTableDeleteConfirmText: "刪除地區號碼",
      toolbarAreaNumberTableDeleteConfirmInformation: "確定刪除該地區號碼?",
      toolbarAreaNumberTableDelConfirmText: "刪除地區號碼",
      toolbarAreaNumberTableDelConfirmInformation: "確定刪除改地區號碼",
      toolAreaNumberTableEditOpenText: "修改地區號碼",
      toolAreaNumberTableEditBtnSubmitText: "提交",
      toolAreaNumberTableEditBtnCancelText: "取消",
      initTableAreaTitle: "地區名稱",
      initTableAreaNoTitle: "區號",
      initTableCreateTime: "創建時間",
      initTableOperation: "操作",
      deleteCodeSortsSuccessText: "刪除字典分類成功",
      placeholder: "查詢地區名稱"
    },
    areaNumberAdd: {
      areaName: "地區名稱:",
      areaCode: "地區區號:",
      userAddFormSuccessText: "新增地區號碼成功"
    },
    areaNumberUpdate: {
      areaCodeId: "地區號碼id:",
      areaName: "地區名稱:",
      areaCode: "地區區號:",
      FormSubmitWarnText: "數據未作任何修改！",
      FormSubmitSuccessText: "數據修改成功"
    }
  },
  dashboard: {
    lineChartTitle: '最近七天提交成功率',
    receiveSuccess: " 今日SMS: 接收成功",
    rechargeAmount: "今日企業充值額",
    waitForSubmitting: "今日SMS: 等待提交",
    // submitSuccess: " 今日SMS: 提交成功",
    queryApiTimes: "今日訪問接口次數",
    totalPayAmount: "今日支付總額",
    rechargeSuccess: "今日充值成功次數",
    submitSuccess: "今日提交上遊成功次數",
    rateSuccessForSevenDays: "最近七天成功成功率",
    rateSuccess: "提交成功率",
    receiptSuccessForSevenDays: "最近七天回執成功率",
    receiptSuccess: "回執成功率",
    payAmount: "支付總金額",
    mon: "星期一",
    tue: "星期二",
    wed: "星期三",
    thu: "星期四",
    fri: "星期五",
    sat: "星期六",
    sun: "星期日",
    top5SuccessRate: "昨天成功率最高的五位企業",
    top6Channels: "昨天成功率最高的六位通道商",
    top5PayCurrency: "今日當前各貨幣支付金額",
    top5FailureRate: "昨天失敗率最高的五位企業",
    successRate: "成功率",
    failureRate: "失敗率",
    top10SmsCount: "昨天支付總額最高的前十企業",
    top10SmsCountTotal: "支付總額",
    top10Agent: "昨天企業充值總額前十的代理",
    top10PaymentYesterday: '昨天充值前十的通道',
    goodAfternoon: '下午好',
    lastLoginTime: '上次登錄時間',
    lastLoginIp: '上次登錄地址',
    welcome: '歡迎登錄',
    moneyUnit: '元',
    agent: {
      agentLabel: '代理名稱',
      sendSMSTotal: '發送總數',
      numOfOrgs: '10日內活躍企業數量',
      smsUnit: '條',
      orgUnit: '間',
      availableQuota: '可用額度',
      rechargeTotal: '充值總額',
      frozenAmount: '凍結金額',
      uncreditedAmount: '未入賬金額',
      overall: '合計',
      availableProfit: '可用利潤',
      totalConsumption: '消費總額',
      queryAPIToday: '今日訪問API',
      paySuccessToday: '今日充值成功',
      enterpriseRechargeTotal: '企業充值總額',
      SmsSent: '短信數量',
      successTotal: '成功數',
      today: '當天',
      profit: '利潤',
      cost: '成本',
      top5Orgs: '信息發送量前五的企業',
      top10Orgs: '支付總額前十的企業'
    },
    merchant: {
      normal: "正常",
      blocked: "鎖定",
      unsuccessful: "未成功",
      approved: "認證通過",
      notApproved: "認證失敗",
      redirectToDocs: '接口文檔',
      availableBalance: '可用金額',
      moneyUnit: '元',
      consumptionAmount: '消費金額',
      frozenAmount: '凍結金額',
      uncreditedAmount: '未入賬金額',
      totalSMSSent: '發送總數',
      totalRecharge: '充值總額',
      smsUnit: '條',
      companyInformation: '企業信息',
      organizationName: '企業名稱',
      organizationStatus: '企業狀態',
      approvalStatus: '認證狀態',
      organizationCode: '企業編號',
      md5Key: 'MD5秘鑰',
      accessNumber: '接入號碼',
      accessCode: '接入密碼',
      numberOfConnections: '連接數',
      channelRate: '速率',
      goToDocs: '接口文檔',
      HTTPAPIText: 'HTTP對接',
      SMPPAPIText: 'SMPP對接',
      top5SmsSent: '前五天提交成功的信息量',
      top5Pay: '前五天支付成功金額',
      numSuccesses: '成功數量'
    }
  },
  common: {
    admin: "管理用戶",
    agent: "代理用戶",
    merchant: "企業用戶",
    currencyType: '貨幣類型',
    HKD: '港幣',
    USD: '美元',
    CNY: '人民幣',
    noData: '沒有數據',
    emailFormat: '電子郵件格式不正確',
    withdraw: "提現",
    networkError: "網絡錯誤",
    warning: "警告",
    required: "必要",
    success: "成功",
    error: "錯誤",
    fetchError: "提取錯誤",
    examinationPassed: "審核通過",
    auditNotPassed: "審核不通過",
    QRCode: "驗證碼",
    permission: "權限",
    userAuthorityManagement: "權限管理",
    newTariff: "新增資費",
    cost: "網關配置",
    addNew: "添新",
    update: "更改",
    resetPassword: "密碼重置",
    batchLock: "批量鎖定",
    batchUnlock: "批量解鎖",
    invalid: "作廢",
    reject: "認證失敗",
    approve: "認證通過",
    recharge: "充值",
    return: "返回",
    add: "新增",
    edit: "修改",
    delete: "刪除",
    search: "查詢",
    stop: "停頓",
    buildAndStart: "創建和起動",
    import: "導入",
    export: "導出",
    exportNumber: "導出號碼",
    exportAreaReport: "導出地區號碼",
    exportBrokenNumber: "導出破叫號碼",
    checkNumberList: "查看號碼列表",
    exportDailyReport: "導出每日報告",
    exportMonthlyReport: "導出每月報告",
    addPreviousDailyReport: "添加前一天報告",
    addPreviousMonthlyReport: "添加前一月報告",
    uploadNumberPool: "號碼池功能",
    deleteNumberPool: "號碼池刪除",
    createTime: "創建時間",
    creator: "創建者",
    updateTime: "修改時間",
    editor: "修改者",
    remark: "備註",
    oldPassword: "舊密碼",
    password: "密碼",
    confirmPassword: "確認密碼",
    submit: "提交",
    reset: "重置",
    cancel: "取消",
    confirm: "確定",
    updateMerchant: "搶單",
    uploadedMerchant: "更新憑證",
    uploadMerchant: "上傳憑證",
    showImage: "顯示憑證",
    queryKid: "查詢Id",
    queryAgent: "查詢代理",
    queryMerchant: "查詢碼商",
    queryReviewAccount: "查詢審核賬號",
    updateAdmin: "審核",
    refuse: "拒絕審核",
    changePwd: "修改密碼",
    updateStatus: "狀態更新",
    forceChangePwd: "修改密碼",
    resetMFASecret: "重置Google驗證",
    resetPwd: "重置密碼",
    frozen: "凍結",
    restore: "恢復",
    fromTime: "開始時間",
    toTime: "結束時間",
    fromData: "開始日期",
    toDate: "結束日期",
    checkDailyReportData: "查看當天的數據",
    reportExportText: "表格導出",
    viewStatisticText: "查看統計",
    date: "日期",
    time: "時間",
    uploadDocumentMessage: "選擇檔案",
    usernameText: "用戶名",
    contentText: "內容",
    batchNumber: "批次號",
    operator: "平臺",
    statusText: "狀態",
    operationText: "操作",
    start: "啟動",
    pause: "暫停",
    toText: "至",
    createTimeText: "創建時間",
    lockTimeText: "鎖定時間",
    pleaseEnterText: "請輸入",
    pleaseSelectText: "請選擇",
    pleaseClickText: "請點擊",
    batchDeleteText: "批量刪除",
    batchUpdatePermissionText: "批量更新權限",
    systemWarning: '系統提示',
    noPermissionWarning: "您沒有權限訪問該資源，請聯系管理員",
    goBack: '退回',
    invalidTokenWarning: "登錄已超時或者賬號在別處登錄，請重新登錄",
    login: '登入',
    cancelUser: "批量作廢",
    clickToShowImage: "圖片",
    notedText: "已讀",
    closedText: "關閉",
    previewText: "預覽",
    remarkText: "備註",
    forceText: "強製",
    notForceText: "非強製",
    callbackDown: "通知下游",
    regetNotify: "重新獲取通知",
    notifyDetail: "回執詳情",
    unknownText: "Unknown"
  },
  route: {
    organizationRechargeManagement: '充值管理',
    channelOperatorDailyReport: '通道運營商日報表',
    channelOperatorMonthlyReport: '通道運營商月報表',
    bindGoogleCode: '綁定谷歌碼',
    payPasswordUpdate: '修改支付密碼',
    personalAccountManagement: '賬號管理',
    passwordUpdate: '密碼修改',
    channelNumberPoolManagement: '號碼池管理',
    batchSuccessRate: '批次成功率',
    exportedExcel: '導出報表',
    totalDailyReport: '總日報',
    generalDailyReport: '綜合日報表',
    allConsumeAmountDailyReport: '全部資費日報表',
    allConsumeAmountMonthlyReport: '全部資費月報表',
    consumeAmountDailyReport: '資費詳情日報表',
    consumeAmountMonthlyReport: '資費詳情月報表',
    agentDailyReport: '代理日報表',
    organizationDailyReport: '企業日報表',
    systemManagement: '系統管理',
    userManagement: '用戶管理',
    menuManagement: '菜單管理',
    departmentManagement: '部門管理',
    dictionaryCategory: '字典分類',
    dictionaryManagement: '字典管理',
    regionManagement: '地區管理',
    loginBlackList: "登入黑名單",
    agentManagement: '代理管理',
    agentCost: "代理網關",
    agentPermission: '代理權限',
    agentSettings: '代理配置',
    agentBlackList: "代理黑名單",
    organizationManagement: '企業管理',
    organizationCost: "企業網關",
    organizationUserPermission: '企業用戶權限',
    organizationOperationLog: '企業操作日誌',
    organizationBlacklist: "企業黑名單",
    organizationUserSettings: '企業用戶配置',
    financeManagement: '財務管理',
    agentConversionQuotaList: '代理轉換額度列表',
    agentRechargeOrder: '代理充值訂單',
    organizationRechargeOrder: '企業充值訂單',
    organizationMonthlyReport: '企業月報表',
    reportManage: '報表管理',
    agentMonthlyReport: '代理月報表',
    channelDailyReport: '通道日報表',
    agentRemitOrder: '代理提現訂單',
    agentRemitOrderReport: '代理提現訂單報表',
    organizationRemitOrder: '企業提現訂單',
    organizationRemitOrderReport: '企業提現訂單報表',
    amountChangeRecord: '金額變動記錄',
    organizationAmountChangeRecord: '企業金額變動記錄',
    organizationAmountChangeRecordReport: '企業金額變動記錄報表',
    agentAmountChangeRecord: '代理金額變動記錄',
    agentAmountChangeRecordReport: '代理金額變動記錄報表',
    organizationUserManagement: '企業用戶管理',
    channelMonthlyReport: '通道月報表',
    orderManagement: "訂單管理",
    orderRecords: "充值訂單記錄",
    orderRecordsReport: "充值訂單記錄報表",
    orderNotify: "充值訂單回執",
    orderNotifyReport: "充值訂單回執報表",
    refundOrder: "退款訂單記錄",
    refundOrderReport: "退款訂單記錄報表",
    orderHistoryManagement: "歷史訂單管理",
    orderRecordsHistory: "歷史充值訂單記錄",
    orderNotifyHistory: "歷史充值訂單回執",
    refundOrderHistory: "歷史退款訂單記錄",
    smsManagement: '短信管理',
    smsTemplateManagement: "短信模板",
    smsSendBox: "發件箱",
    smsSendRecord: "發送記錄",
    smsReturnRecord: "發送回執",
    smsWaitingApproval: "等待審核",
    smsManualApproval: "人工發送審核",
    smsScheduledMsg: "定時短信",
    smsBlacklist: "手機黑名單",
    smsSensitiveWords: "敏感詞",
    smsSendBoxSubmitByForm: "我要發送",
    smsSendBoxSubmitByTable: "表格提交",
    smsSendBoxBatchSubmitByForm: "我要發送(動態內容)",
    smsSendBoxSubmitByTemplate: "模板提交",
    sendCreateTimeList: "發送創建時間列表",
    smsChannelGroup: "通道分組管理",
    payChannelGroup: "通道分組管理",
    smsChannelGroupChannel: "通道分組通道明細",
    smsChannelGroupMember: "通道分組成員明細",
    smsChannelGroupCost: "通道分組資費組合明細",
    payChannelGroupCost: "通道分組資費組合明細",
    payChannelGroupCostMember: "通道分組資費組合成員明細",
    channelManagement: "通道管理",
    groupManagement: "分組管理",
    groupMember: "分組明細",
    channelNumberPoolLog: "號碼池日誌",
    smsChannel: "短信通道",
    smsChannelCost: "短信通道資費",
    payChannel: "支付通道",
    payChannelCost: "支付通道資費",
    currencyExchangeRate: "貨幣轉換匯率",
    historyRecord: "歷史記錄",
    historySendBox: "歷史發件箱",
    historySentRecord: "歷史發送記錄",
    historyReturnedRecord: "歷史發送回執",
    historySendBoxSearch: "歷史發件箱(查詢)",
    historySentRecordSearch: "歷史發送記錄(查詢)",
    historyReturnedRecordSearch: "歷史發送回執(查詢)",
    monitorSystem: "系統監控",
    monitorDaily: "系統日誌",
    monitorLogin: "登錄日誌",
    scheduledTaskTitle: "任務調度",
    scheduledTask: "定時任務",
    scheduledTaskLog: "調度日誌",
    scheduledSMS: "定時短信",
    scheduledSMSLog: "定時短信日誌",
    agentSmsManagement: '短信管理(代理)',
    agentSmsSendBox: "發件箱(代理)",
    agentSmsSendRecord: "發送記錄(代理)",
    agentHistorySendBox: "歷史發件箱(代理)",
    agentHistorySendRecord: "歷史發送記錄(代理)",
    orderList: "訂單列表",
    withdrawList: "提現列表",
    grabOrder: "搶單列表",
    dashboard: "首頁",
    documentation: "文檔",
    guide: "引導頁",
    systemConfig: "系統配置表",
    config: "配置",
    checkData: "查看數據",
    dataQuery: "查詢數據",
    smsQueryAnalysis: "查詢短信分析",
    checkPhone: "查看手機號碼",
    randomFailureNumber: "隨機失敗號碼",
    pastComprehensiveAnalysis: "過往綜合分析",
    comprehensiveDataAnalysis: "短信分析綜合數據",
    companyReport: "公司報告",
    companyDailyReport: "公司每日報告",
    companyMonthlyReport: "公司每月報告",
    realTimeComprehensiveAnalysis: "即時綜合分析",
    receiptNumberAnalysis: "回執號碼分析",
    areaReportAnalysis: "地區號碼分析",
    channelInformationList: "通道信息列表",
    quartzConfig: "定時器配置表",
    channelRateAnalysis: "通道比率分析",
    enterpriseRateAnalysis: "企業比率分析",
    hourlyDataReportAnalysis: "每小時成功率分析",
    accountManagement: "用戶管理",
    accountView: "用戶列表",
    roleManagement: "角色管理",
    permission: "權限測試頁",
    rolePermission: "角色權限",
    pagePermission: "頁面權限",
    directivePermission: "指令權限",
    icons: "圖標",
    components: "組件",
    tinymce: "富文本編輯器",
    markdown: "Markdown",
    jsonEditor: "JSON 編輯器",
    dndList: "列表拖拽",
    splitPane: "Splitpane",
    avatarUpload: "頭像上傳",
    dropzone: "Dropzone",
    sticky: "Sticky",
    countTo: "Count To",
    componentMixin: "小組件",
    backToTop: "返回頂部",
    dragDialog: "拖拽 Dialog",
    dragSelect: "拖拽 Select",
    dragKanban: "可拖拽看板",
    charts: "圖表",
    keyboardChart: "鍵盤圖表",
    lineChart: "折線圖",
    mixChart: "混合圖表",
    example: "綜合實例",
    nested: "路由嵌套",
    menu1: "菜單1",
    "menu1-1": "菜單 1-1",
    "menu1-2": "菜單 1-2",
    "menu1-2-1": "菜單 1-2-1",
    "menu1-2-2": "菜單 1-2-2",
    "menu1-3": "菜單 1-3",
    menu2: "菜單 2",
    Order: "訂單",
    Table: "Table",
    dynamicTable: "動態 Table",
    dragTable: "拖拽 Table",
    inlineEditTable: "Table 內編輯",
    complexTable: "綜合 Table",
    tab: "Tab",
    form: "表單",
    createArticle: "創建文章",
    editArticle: "編輯文章",
    articleList: "文章列表",
    errorPages: "錯誤頁面",
    page401: "401",
    page404: "404",
    errorLog: "錯誤日誌",
    excel: "Excel",
    exportExcel: "導出 Excel",
    selectExcel: "導出 已選擇項",
    mergeHeader: "導出 多級表頭",
    uploadExcel: "上傳 Excel",
    zip: "Zip",
    pdf: "PDF",
    exportZip: "Export Zip",
    theme: "換膚",
    clipboardDemo: "Clipboard",
    i18n: "國際化",
    externalLink: "外鏈",
    profile: "個人中心"
  },
  navbar: {
    dashboard: "首頁",
    github: "項目地址",
    logOut: "退出登錄",
    profile: "個人中心",
    theme: "換膚",
    size: "布局大小",
    enterFullScreen: '進入全屏幕',
    exitFullScreen: '退出全屏幕',
    switchLanguage: '更換語言',
    refreshCache: '刷新緩存'
  },
  login: {
    capslockOn: '大寫鎖定已打開',
    emailError: "請輸入正確的用戶名",
    passwordError: "密碼不能少於6位數字",
    title: "系統登錄",
    titleAdmin: "管理系統登錄",
    titleAgent: "代理系統登錄",
    titleMerchant: "企業系統登錄",
    logIn: "登錄",
    username: "賬號",
    password: "密碼",
    any: "隨便填",
    thirdparty: "第三方登錄",
    thirdpartyTips: "本地不能模擬，請結合自己業務進行模擬！！！",
    authenticator: "Google驗證碼",
    rememberMe: "記住我"
  },
  documentation: {
    documentation: "文檔",
    github: "Github 地址"
  },
  permission: {
    addRole: "新增角色",
    editPermission: "編輯權限",
    roles: "你的權限",
    switchRoles: "切換權限",
    tips: "在某些情況下，不適合使用 v-permission。例如：Element-UI 的 el-tab 或 el-table-column 以及其它動態渲染 dom 的場景。你只能通過手動設置 v-if 來實現。",
    delete: "刪除",
    confirm: "確定",
    cancel: "取消"
  },
  guide: {
    description: "引導頁對於一些第一次進入項目的人很有用，你可以簡單介紹下項目的功能。本 Demo 是基於",
    button: "打開引導"
  },
  components: {
    documentation: "文檔",
    tinymceTips: "富文本是管理後臺一個核心的功能，但同時又是一個有很多坑的地方。在選擇富文本的過程中我也走了不少的彎路，市面上常見的富文本都基本用過了，最終權衡了一下選擇了Tinymce。更詳細的富文本比較和介紹見",
    dropzoneTips: "由於我司業務有特殊需求，而且要傳七牛 所以沒用第三方，選擇了自己封裝。代碼非常的簡單，具體代碼你可以在這裏看到 @/components/Dropzone",
    stickyTips: "當頁面滾動到預設的位置會吸附在頂部",
    backToTopTips1: "頁面滾動到指定位置會在右下角出現返回頂部按鈕",
    backToTopTips2: "可自定義按鈕的樣式、show/hide、出現的高度、返回的位置 如需文字提示，可在外部使用Element的el-tooltip元素",
    imageUploadTips: "由於我在使用時它只有vue@1版本，而且和mockjs不兼容，所以自己改造了一下，如果大家要使用的話，優先還是使用官方版本。"
  },
  partner: {
    dynamicTips1: "固定表頭, 按照表頭順序排序",
    dynamicTips2: "不固定表頭, 按照點擊順序排序",
    dragTips1: "默認順序",
    dragTips2: "拖拽後順序",
    name: "名稱",
    rate: "費率",
    money: "金額",
    search: "搜索",
    add: "添加",
    amount: "余額",
    rechangeAmount: "總充值金額",
    customeAmount: "總消耗金額",
    freeze: "凍結金額",
    export: "導出",
    reviewer: "審核人",
    id: "序號",
    date: "更新時間",
    author: "作者",
    readings: "閱讀數",
    status: "狀態",
    actions: "操作",
    edit: "編輯",
    publish: "發布",
    draft: "草稿",
    delete: "刪除",
    cancel: "取 消",
    confirm: "確 定",
    phone: "手機",
    email: "郵箱",
    account: "登錄賬戶",
    pwd: "密碼",
    againPwd: "再次輸入",
    merchantName: "商戶名稱",
    merchantId: "商戶ID",
    currentAmount: "當前金額",
    opAmount: "變動金額",
    odAmount: "已變動金額",
    actualAmount: "實際金額",
    type: "類型",
    partner: "接入ID",
    openApiAccountName: "接人名稱",
    orderNo: "單號"
  },
  order: {
    dynamicTips1: "固定表頭, 按照表頭順序排序",
    dynamicTips2: "不固定表頭, 按照點擊順序排序",
    dragTips1: "默認順序",
    dragTips2: "拖拽後順序",
    name: "名稱",
    rate: "費率",
    money: "金額",
    search: "搜索",
    add: "添加",
    amount: "余額",
    rechangeAmount: "總充值金額",
    customeAmount: "總消耗金額",
    freeze: "凍結金額",
    export: "導出",
    reviewer: "審核人",
    id: "序號",
    date: "更新時間",
    author: "作者",
    readings: "閱讀數",
    status: "狀態",
    actions: "操作",
    edit: "編輯",
    publish: "發布",
    draft: "草稿",
    delete: "刪除",
    cancel: "取 消",
    confirm: "確 定",
    create_time: "創建時間",
    finish_time: "完成時間",
    update_time: "更新時間",
    pdd_confirm_time: "確認收貨時間",
    pdd_send_time: "發貨時間",
    open_api_account_kid: "合作商id",
    order_no: "訂單號",
    user_order_no: "第三方訂單號",
    order_mobile: "下單號碼",
    pay_url: "支付地址",
    pdd_status: "收貨狀態",
    review_time: "審核時間",
    partner_info: "合作商戶信息",
    partner_kid: "合作商戶id",
    partner_name: "合作商戶名稱",
    review_user_info: "審核人信息",
    review_user_kid: "審核人Id",
    review_user_name: "審核人名稱",
    bank_address: "銀行信息",
    card: "銀行卡號",
    withdraw_info: "提現人信息",
    agent_kid: "代理id",
    merchant_kid: "合作商id",
    review_account_kid: "審核人id",
    start_create_time: "創建開始時間",
    end_create_time: "結束開始時間",
    agent_info: "代理相關",
    certificate_url: "憑證照片",
    msgId: "回執ID",
    resMsg: "回執信息",
    notifyTime: "回執時間",
    notifyProperty: "回執參數"
  },
  table: {
    dynamicTips1: '固定表頭, 按照表頭順序排序',
    dynamicTips2: '不固定表頭, 按照點擊順序排序',
    dragTips1: '默認順序',
    dragTips2: '拖拽後順序',
    title: '標題',
    importance: '重要性',
    type: '類型',
    remark: '備註',
    search: '搜索',
    add: '添加',
    export: '導出',
    reviewer: '審核人',
    id: '序號',
    date: '時間',
    author: '作者',
    readings: '閱讀數',
    status: '支付狀態',
    actions: '操作',
    edit: '編輯',
    publish: '發布',
    draft: '草稿',
    delete: '刪除',
    cancel: '取 消',
    confirm: '確 定'
  },
  example: {
    warning: "創建和編輯頁面是不能被 keep-alive 緩存的，因為keep-alive 的 include 目前不支持根據路由來緩存，所以目前都是基於 component name 來進行緩存的。如果你想類似的實現緩存效果，可以使用 localStorage 等瀏覽器緩存方案。或者不要使用 keep-alive 的 include，直接緩存所有頁面。詳情見"
  },
  errorLog: {
    tips: "請點擊右上角bug小圖標",
    description: "現在的管理後臺基本都是spa的形式了，它增強了用戶體驗，但同時也會增加頁面出問題的可能性，可能一個小小的疏忽就導致整個頁面的死鎖。好在 Vue 官網提供了一個方法來捕獲處理異常，你可以在其中進行錯誤處理或者異常上報。",
    documentation: "文檔介紹"
  },
  excel: {
    export: "導出",
    selectedExport: "導出已選擇項",
    placeholder: "請輸入文件名(默認excel-list)"
  },
  zip: {
    export: "導出",
    placeholder: "請輸入文件名(默認file)"
  },
  pdf: {
    tips: "這裏使用   window.print() 來實現下載pdf的功能"
  },
  theme: {
    change: "換膚",
    documentation: "換膚文檔",
    tips: "Tips: 它區別於 navbar 上的 theme-pick, 是兩種不同的換膚方法，各自有不同的應用場景，具體請參考文檔。"
  },
  tagsView: {
    refresh: "刷新",
    close: "關閉",
    closeOthers: "關閉其它",
    closeAll: "關閉所有"
  },
  settings: {
    title: "系統布局配置",
    theme: "主題色",
    tagsView: "開啟 Tags-View",
    fixedHeader: "固定 Header",
    sidebarLogo: "側邊欄 Logo"
  },
  SMS: {
    msgIdText: '商戶訂單號',
    superiorAgentIncome: '上級代理收益',
    AutomaticConfiguration: '自動配置',
    remark: '備註',
    verificationCode: '驗證碼',
    rechargeAmount: '充值金額',
    increaseAmount: '增加金额',
    convertAmount: '轉換后金額',
    exchangeRate: '匯率',
    moneyTypeFrom: '原始幣種',
    moneyTypeTo: '目標幣種',
    moneyTypeToReport: '支付所用貨幣類型',
    rechargeMethod: '充值方式',
    agentId: '代理商',
    agentNameText: "代理商",
    organizationName: '企業名稱',
    salesman: '銷售人',
    status: '狀態',
    approveState: '認證狀態',
    checkNumberCountState: '號碼條數審核狀態',
    username: '用戶名',
    organizationCode: '企業編號',
    loginAccount: '登錄賬號',
    fullName: '姓名',
    totalRechargeYuan: '充值總額',
    amountAvailableYuan: '可用金額',
    consumptionAmountYuan: '消費金額',
    frozenAmount: '凍結金額',
    uncreditedAmount: '待入帳金額',
    numberOfSent: '發送條數',
    smppConnectionStatus: 'smpp連接狀態',
    smsApproveType: '短信審核',
    createTime: '創建時間',
    operating: '操作',
    interfaceType: '開通接口',
    delayedSettlement: '延時結算',
    bindIP: '綁定IP',
    smsSignature: '短信簽名',
    corporateWebsite: '企業網站',
    companyAddress: '企業地址',
    enterpriseMailbox: '企業郵箱',
    contactNumber: '聯系電話',
    contactPerson: '聯系人',
    confirmPassword: '確認密碼',
    password: '密碼',
    alarm: '警報',
    success: '成功',
    accountType: '賬號類型',
    lastLoginIPAddress: '上次登錄IP地址',
    lastLoginTime: '上次登錄時間',
    pleaseSelectUserType: '請選擇用戶類型',
    balanceProcessing: '余額處理',
    tariffName: '資費名稱',
    tariff: '資費',
    smsType: '短信類型',
    areaCode: '地區區號',
    channel: '通道',
    operationUser: '操作用戶',
    operationContent: '操作內容',
    operationMethod: '操作方法',
    timeConsuming: '耗時',
    methodParameters: '方法參數',
    methodResponse: '返回參數',
    ipAddress: 'IP地址',
    operatingLocation: '操作地點',
    canNotBeEmpty: '不能為空',
    contactMobile: '聯系電話',
    workingFor: '正在為',
    description: '描述',
    name: '名稱',
    accountCannotBeEmpty: '賬號不能為空',
    rolePermissions: '角色權限',
    updateRolePermissions: '更新角色權限',
    parentId: '上級ID',
    type: '類型',
    icon: '圖標',
    permission: '權限',
    sequence: '排序',
    createNewUser: '添加新用戶',
    editUser: '修改用戶',
    create: '添加',
    update: '更新',
    viewUser: '查看用戶',
    levelCode: '級別',
    systemName: '平臺名稱',
    smsDomainAddress: '域名地址',
    platformLOGO: '平臺LOGO',
    platformBackgroundImage: '平臺背景圖片',
    upAgentId: '上級代理商',
    amountOfProfit: '利潤金額',
    userStatus: '用戶狀態',
    numberOfFailedLogins: '登錄失敗次數',
    agentName: '名稱',
    agentAccount: '用戶名',
    payPassword: '支付密碼',
    phoneNumber: '手機號',
    email: '郵箱',
    changeAmount: '最高轉換額度',
    bingQrcode: '綁定谷歌碼',
    unboundVerificationCode: '未綁定驗證碼',
    manipulator: '操作者',
    profitBeforeOperation: '操作前利潤',
    profitAfterOperation: '操作後利潤',
    operationAmount: '操作金額',
    amountAvailableAfterOperation: '操作後可用金額',
    submissionTime: '提交時間',
    orderNumber: '訂單編號',
    rechargeType: '充值類型',
    netwayCode: '充值方式',
    reqStateCode: '請求狀態',
    rechargeStateCode: '充值狀態',
    createUser: '創建用戶',
    rechargeCompleteTime: '充值完成時間',
    founder: '創建人',
    payChannelId: '通道',
    payMerchNo: '通道商戶號',
    rechargeCompletionTime: '充值完成時間',
    requestStatusDescription: '請求狀態描述',
    agentRemitOrder: '代理現提訂單',
    organizationRemitOrder: '企業現提訂單',
    remitType: "提現類型",
    withdrawalAmount: '提現金額',
    approvalStatus: '審核狀態',
    bankName: '銀行名稱',
    bankCardNumber: '銀行卡號',
    branchName: '支行名稱',
    transferVoucher: '轉賬憑證',
    rejectReason: '拒絕原因',
    availableProfit: '可用利潤',
    availableProfitBefore: '操作前可用利潤',
    examinationPassed: '審核通過',
    accountName: '開戶姓名',
    statisticsDate: '統計日期',
    export: '導出',
    total: '總數',
    totalNumberOfOutbox: '發件箱總條數',
    billingNumberOfOutbox: '發件箱計費條數',
    sortingFailed: '分揀失敗',
    toBeSent: '待發送',
    submittedSuccessfully: '提交成功',
    submissionFailed: '提交失敗',
    successfullyReceived: '接收成功',
    receiveFailed: '接收失敗',
    successRate: '成功率',
    amountOfConsumption: '充值金額',
    amountPerSMSCount: '單條消費金額',
    costValue: '資費',
    agencyProfit: '代理利潤',
    upAgencyProfit: '上級代理收益',
    channelCost: '通道成本',
    profit: '利潤',
    date: '日期',
    enterpriseMonthlyReport: '企業月報表',
    channelName: '通道名稱',
    tiao: '條',
    yuan: '元',
    totalText: '共計',
    platformProfit: '平臺利潤',
    corporateDailyReport: '企業日報表',
    statistic: '查看統計',
    batchNumber: '批次號',
    operator: '運營商',
    totalDailyReport: '總日報表',
    statistics: '統計信息',
    agentMonthlyReport: '代理月報表',
    sixMonthData: '6個月內總數數據',
    sixMonthDataForApi: '6個月內訪問接口次數',
    sixDayData: '6天內總數數據',
    sixDayDataForApi: '6天內訪問接口次數',
    numberPool: '號碼池',
    usageCount: '使用次數',
    useNumberPool: '使用號碼池',
    oldPassword: '原始密碼',
    newPassword: '新密碼',
    oldPayPassword: '原始支付密碼',
    newPayPassword: '新支付密碼',
    confirmPayPassword: '確認支付密碼',
    loginFailedCount: '登入失敗次數',
    conversionAmount: '轉換額度',
    withdraw: '提現',
    remitAmount: '提現余額',
    dollar: '元',
    channelMonthlyReport: '通道月報表',
    loginPassword: '登錄密碼',
    newLoginPassword: '新登錄密碼',
    smsContent: '消息內容',
    pleaseEnterText: '請輸入',
    pleaseChoose: '請選擇',
    googleQrCode: '谷歌二維碼',
    forceLogoffText: "強製登出",
    removeGoogle: "解綁google二維碼",
    bankCode: '銀行名稱',
    bankBranch: '分行名稱',
    bankAccountName: '開戶姓名',
    bankAccountNo: '銀行卡號',
    availableAmount: '可用金額',
    error: '錯誤',
    googleVerifyCode: '谷歌驗證碼',
    lastUseTime: '最後使用時間',
    forceBindGoogleText: "強製綁定谷歌驗證碼",
    activeUserText: "活躍用戶",
    isStoredGoogleText: "谷歌驗證碼狀態",
    notifyUrl: "通知地址",
    channelId: "通道",
    totalSMSText: '總短信數',
    totalChannelText: '總通道數',
    totalChannelOperatorText: '總運營商數',
    totalAgentText: '總代理數',
    totalOrgText: '總企業數',
    consumeAmountDailyExcelText: "資費詳情日報表.xlsx",
    consumeAmountMonthlyExcelText: "資費詳情月報表.xlsx",
    activeUserTimeRangeText: "活躍用戶時間",
    exportActiveUserReportText: "導出活躍用戶表",
    activeUserExcelText: "活躍用戶表.xlsx",
    weightingOrg: "權重",
    upNotifyTime: "上游通知時間",
    downNotifyTime: "下游通知時間",
    settleTime: "結算時間",
    orderCreateFailCount: "創建失敗",
    orderCreateSuccessCount: "創建成功",
    channelSubmitFailCount: "提交失敗",
    channelSubmitSuccessCount: "提交成功",
    channelNotifyFailCount: "通知失敗",
    channelNotifySuccessCount: "通知成功",
    refundCount: '退款',
    depositedCount: '入賬'
  },
  organizationUserSettings: {
    excelFormatText: "報表檔案格式",
    rowLimitText: "行數"
  },
  option: {
    manual: '手動',
    automatic: '自動',
    pending: '待審核',
    examinationPassed: '審核通過',
    auditNotPassed: '審核不通過',
    platformRecharge: '平臺充值',
    agentRecharge: '代理充值',
    transactionRecharge: '交易充值',
    success: '成功',
    failure: '失敗',
    signatureError: '簽名錯誤',
    otherErrors: '其它錯誤',
    unpaid: '未支付',
    initial: '初始',
    menu: '菜單',
    button: '按鈕',
    mainAccount: '主賬號',
    subAccount: '子賬號',
    pleaseChoose: '請選擇',
    templateExemption: '模板免審',
    templateSendOnly: '模板發送',
    manualReview: '人工審核',
    exemption: '免審',
    doNotUse: '不使用',
    use: '使用',
    regular: '正常',
    locking: '鎖定',
    invalid: '作廢',
    notApproved: '未認證',
    approved: '認證通過',
    rejected: '認證失敗',
    donTDealWith: '不處理',
    transferToProcessing: '轉入處理',
    alipay: '支付寶',
    alipayHK: '支付寶香港',
    alipayApp: '支付寶App',
    alipayAppHK: '支付寶App香港',
    wechat: '微信',
    wechatHK: '微信香港',
    wechatH5: '微信H5',
    wechatH5HK: '微信香港H5',
    wechatApp: '微信App',
    wechatAppHK: '微信App香港',
    weChatPayMiniProgram: '微信小程序支付',
    AlipayMiniProgramHK: '支付寶小程序HK',
    AlipayMiniProgramCN: '支付寶小程序CN',
    ApplePayCNTest: 'Apple Pay測試',
    GooglePayTest: 'Google Pay測試',
    SecureAcceptanceTest: '信用卡支付測試',
    wechatAppByWeChat: '微信App(微信直營)',
    paypalHK: 'PayPal香港',
    paypalUS: 'PayPal美國',
    applePay: '蘋果支付',
    applePayCN: '蘋果支付中國',
    googlePay: '谷歌支付',
    secureAcceptance: 'Secure Acceptance',
    cyberSource: 'CyberSource',
    onlineBanking: '網銀',
    enterpriseAbolishedAndTransferredIn: '企業作廢轉入',
    sms: '短信',
    domestic: '國內',
    hongKong: '香港',
    normal: '正常',
    malaysia: '馬來西亞',
    chinaHongKong: '中國香港',
    deleteTariff: '刪除資費',
    smsContent: '消息內容',
    cancel: "作廢",
    CTCC: "電信",
    CMCC: "移動",
    CUCC: "聯通",
    unknownChannelOperator: "未知運營商",
    SMS: "短信",
    PSBC: "中國郵政儲蓄銀行",
    SPDB: "上海浦東發展銀行",
    CNCB: "中信銀行",
    CIB: "興業銀行",
    HXB: "華夏銀行",
    CMBC: "中國民生銀行",
    CEB: "中國光大銀行",
    CMB: "招商銀行",
    BCM: "交通銀行",
    CCB: "中國建設銀行",
    ICBC: "中國工商銀行",
    ABC: "中國農業銀行",
    BOC: "中國銀行"
  },
  message: {
    h: '時',
    m: '分',
    s: '秒',
    timeDiff: '回執相隔時間',
    titletable: '表格提交',
    title: '我要發送',
    submitByTemplateTitle: '模板提交',
    message1: "將會刪除數據。繼續？",
    permissionMessage1: "將會刪除記錄，記錄如果包含子記錄，也會被一並刪除，繼續？",
    organizationManagementMessage2: "認證通過已取消",
    message3: "刪除已取消",
    organizationManagementMessage4: "刪除成功!",
    message5: "刪除失敗!",
    message6: "添加成功",
    organizationManagementMessage7: "暫停成功",
    organizationManagementMessage8: "暫停失敗",
    message9: "認證通過成功",
    message10: "認證通過失敗",
    message11: "認證失敗成功",
    message12: "認證失敗失敗",
    organizationManagementMessage13: "密碼長度為8到20之間",
    organizationManagementMessage14: "兩次密碼不一致",
    organizationManagementMessage15: "用戶名長度在6到20之間",
    message16: "請至少選擇一個數據進行操作！（在數據最左邊的復選框打√）",
    organizationManagementMessage17: "非有效電話號碼，目前只支持大陸電話",
    message18: "充值成功",
    organizationManagementMessage19: "作廢成功",
    organizationManagementMessage20: "資費添加成功",
    organizationManagementMessage21: "资费更新成功",
    message21: "會將認證狀態改為認證通過。繼續？",
    message22: "會將認證狀態改為認證失敗。繼續？",
    message23: "認證失敗已取消！",
    organizationManagementMessage24: "作廢失敗！",
    message25: "認證通過已取消！",
    message26: "充值失敗！",
    organizationManagementMessage27: "將會鎖定數據。繼續？",
    organizationManagementMessage28: "鎖定成功！",
    organizationManagementMessage29: "鎖定失敗！",
    organizationManagementMessage30: "將會解鎖數據。繼續？",
    organizationManagementMessage31: "鎖定數據已取消。",
    organizationManagementMessage32: "解鎖數據已取消。",
    organizationManagementMessage33: "解鎖成功。",
    organizationManagementMessage34: "解鎖失敗。",
    message35: "將會重置密碼。繼續？",
    message36: "重置密碼已取消！",
    message37: "重置密碼成功！",
    message38: "重置密碼失敗！",
    Message39: "請選擇一個菜單",
    message40: "添加失敗",
    message41: "修改成功",
    message42: "修改失敗",
    organizationManagementMessage43: "更新角色權限成功",
    organizationManagementMessage44: "更新角色權限失敗",
    message45: "數據未做任何修改",
    message46: "會將審核狀態改為審核通過。繼續？",
    message47: "會將審核狀態改為審核不通過。繼續？",
    message48: "審核不通過已取消！",
    message49: "審核通過已取消！",
    message50: "審核通過成功！",
    message51: "審核通過失敗！",
    message52: "審核不通過成功！",
    message53: "審核不通過失敗！",
    message54: "請選擇轉賬憑證",
    batchNumberText: "批次號",
    phoneNumberText: "手機號碼",
    operatorText: "代理商",
    organizationNameText: "企業名稱",
    subordinateAgentNameText: "下級代理名稱",
    organizationIDText: "企業編號",
    smsContentText: "消息內容",
    informationTypeText: "消息類型",
    auditStatusText: "審核狀態",
    submitMethodText: "提交方式",
    messagesDetailText: "信息詳情",
    submitTimeText: "提交時間",
    submitterText: "提交人",
    createTimeText: "創建時間",
    amountDetailText: "金額詳情",
    updateOrganizationInformationText: "修改信息",
    toText: "至",
    receiveStatusText: "接收狀態",
    requestStatusText: "請求狀態",
    channelText: "通道",
    statusText: "狀態",
    resubmitText: "我要補發",
    totalCustomersText: "總客戶數",
    customerUnitText: "家",
    totalRecord: "總記錄",
    recordUnitText: "條",
    smsCountMessageText: "計費短信數",
    consumeAmountText: "消費金額",
    consumeAmountWithUnitText: "消費金額",
    channelCostText: "通道成本",
    dollarUnitText: "元",
    subordinateAgentIncomeText: "下級代理利潤",
    agentRewardText: "代理利潤",
    agentReward2Text: "利潤",
    agentRewardWithUnitText: "利潤",
    validSMSMessageText: "有效短信數",
    platformRewardText: "平臺利潤",
    todayMaximumSpeedText: "本日最高流速",
    currentSpeedText: "當前流速",
    expectedCompleteTimeText: "預計完成耗時",
    channelOperatorText: "運營商",
    channelOperatorDetailText: "運營商詳情",
    selectBatchMessageResubmitText: "選中批量重發",
    selectBatchMessageResubmitNoticeText: "選中補發通知",
    selectBatchMessageConditionalResubmitText: "條件批量重發",
    selectBatchMessageConditionalResubmitNoticeText: "條件補發通知",
    selectBatchMessageConditionalUpdateReturnSuccessText: "強製回執成功",
    selectBatchMessageConditionalUpdateReturnFailText: "強製回執失敗",
    exportMSGIDText: "導出MSGID",
    exportUpstreamSortingFailText: "導出分揀失敗報表",
    returnTimeText: "回執時間",
    channelMessageLogoText: "通道消息標識",
    phoneNumberCount: "號碼數",
    auditApproveText: "通過審核",
    auditRefuseText: "拒絕審核",
    manualSubmitText: "人工發送",
    manualCancelText: "人工取消",
    agentIDText: "代理商id",
    countryCallingCodesText: "手機號碼歸屬國家編碼",
    phoneNumberSetText: "接收的手機號碼集合(逗號隔開)",
    phoneNumberCountText: "號碼數",
    validMessageNumberText: "有效的短信數",
    messageWordCountText: "短信字數",
    rejectReasonText: "拒絕原因",
    clientIPAddressText: "客戶端ip",
    scheduledTimeText: "定時時間",
    sortingTimeText: "分揀時間",
    agentRevenueText: "代理商收益",
    platformRevenueText: "平臺收益",
    regionText: "地區",
    operationText: "操作",
    addInformationText: "新增信息",
    addChannelText: "新增通道",
    createSimilarChannelText: "創建類似通道",
    updateChannelText: "更新通道",
    addPayChannelText: "新增支付通道",
    updatePayChannelText: "更新支付通道",
    addTemplateText: "新增模板",
    updateTemplateText: "更新模板",
    numberRegionText: "號碼區域",
    addSensitiveWordText: "新增敏感詞",
    sensitiveWordText: "敏感詞",
    sensitiveWordDocumentText: "敏感詞文件",
    supportFormatMessage: "(支持文件格式:txt)",
    templateNameText: "模板名稱",
    templateVariableText: "動態內容",
    templateVariableLocationText: "動態內容位置",
    templateVariableRemarkText: "動態內容備註",
    templateVariableRemarkMessage: "以[]為動態內容位置，短信內容必須與所有非動態內容（包括空格、符號和位置）相同",
    templateVariableExampleText: "動態內容例子",
    templateVariableExampleMessage1: "示例：驗證碼模板＃您的驗證碼：[0]，請勿告知他人！不可時間[1]分鐘！",
    templateVariableExampleMessage2: "實際可發短信內容：驗證碼模板＃您的驗證碼：123456，請勿告知他人！不可時間5分鐘！",
    templateContentText: "模板內容",
    descriptionText: "描述",
    updateInformationText: "修改信息",
    totalText: "共計",
    submitSuccessText: "提交成功",
    submitFailText: "提交失敗",
    receiveSuccessText: "接收成功",
    receiveFailText: "接收失敗",
    receiveUnknownText: "接收未知",
    sortingFailText: "分揀失敗",
    waitingSubmitText: "等待提交",
    successRateText: "成功率",
    mobileSuccessRateText: "移動成功率",
    sendBoxExcelText: "發件箱.xlsx",
    sendBoxHistoryExcelText: "歷史發件箱.xlsx",
    sendRecordExcelText: "發送記錄信息表.xlsx",
    sendRecordHistoryExcelText: "歷史發送記錄信息表.xlsx",
    returnRecordExcelText: "發送回執信息表.xlsx",
    returnRecordHistoryExcelText: "歷史發送回執信息表.xlsx",
    message55: "登錄已失效，請重新登錄",
    message56: "對不起，您暫無該操作權限",
    message57: "密碼修改成功",
    message58: "請填寫正確的域名",
    message59: "添加系統配置成功",
    message60: "將文件拖到此處，或",
    message61: "點擊上傳",
    message62: "只能上傳jpg/png文件，且不超過5120Kb",
    message63: "提示：手機掃碼後請輸入谷歌碼及支付密碼，提交成功以完成谷歌綁定！",
    submitDetailText: "提交詳情",
    returnDetailText: "接收詳情",
    numberDocumentText: "號碼文件",
    dynamicVariableDocumentText: "動態內容參數文件",
    splitNumberText: '批次號碼數',
    remarkSplitNumberMessage: '短信內容跟據批次號碼數生成批次並替換動態內容。如果批次號碼數是500，每500個號碼替換一次動態內容，直到所有號碼處理完畢',
    remarkSplitNumberLimitMessage: "批次號碼數最少需要設為500或500的倍數",
    remarkDynamicVariableInContentMessage: "以##A##為動態內容位置。如果內容沒有'##A##'會提交失敗",
    remarkDynamicVariableInContentExampleMessage: "如果內容是 '你好，##A##' 和動態內容是 '世界'，最後短信內容為 '你好，世界'。",
    smsMessageContentText: "短信內容",
    smsMessageTemplateContentText: "模板短信內容",
    wordCountText: "字數統計",
    scheduledSubmitText: "定時發送",
    remarkText: "註意",
    remarkEnterNumberMessage: "(多個號碼換行或者逗號分割,最多5W個號碼)",
    remarkSMSNumberLimitMessage: "最少需要上傳500條號碼",
    remarkNumberDocumentMessage: "(每個文件最大支持5W個號碼換行或者逗號分割。支持文件格式:txt)",
    remarkDynamicVariableDocumentMessage: "(動態內容參數數量和分割後批次量需要一致，不同數量會提交失敗。支持文件格式:txt)",
    remarkScheduledSendMessage: "(不填為即時發送)",
    remarkIsStoredScheduledTimeMessage: "(不選為提交後清除定時時間)",
    clearScheduledTimeMessage: "清除定時時間",
    notClearScheduledTimeMessage: "不清除定時時間",
    // sendBoxClearScheduledTimeMessage: "發件箱記錄清除定時時間",
    // sendBoxNotClearScheduledTimeMessage: "發件箱記錄不清除定時時間",
    totalWordCountText: "個字符",
    separateText: ",拆分",
    totalMessageText: "條短信",
    remarkReminderMessage: "包含簽名短信小於等於70個字的按70個字一條計費，大於70個字按67字一條計費, 短信內容總字數不能超過 500字",
    tableRemarkNumberDocumentMessage1: "(第一行默認為標題不被導入,第一列必須是手機號碼。",
    tableRemarkNumberDocumentMessage2: "文件大小不超過2M，支持文件格式:Excel2003(xls),Excel2007(xlsx))",
    tableRemarkNumberDocumentMessage3: "點擊此處查看表格提交說明示例",
    numberDocumentListText: "列",
    exampleText: "示例說明",
    viewSMSNumbersText: "查看號碼",
    viewStatusDescText: "通道請求返回信息",
    downloadSMSNumbersText: "下載號碼",
    message64: "重置密碼為",
    message65: "重置密碼為(1234Qwer)!",
    importTemplateText: "模板導入",
    importTemplateRemark1Message: "說明：每個模板占用一行數據,多個模板必須換行！",
    importTemplateRemark2Message: "每行數據格式為：模板名稱 + # + 模板內容",
    importTemplateRemark3Message: "示例：驗證碼模板#您的驗證碼:{0},請勿告知他人!失效時間{1}分鐘!",
    importTemplateRemark4Message: "支持文件格式: txt",
    selectDocumentText: "選擇文件",
    sendBoxCreateTime: "發件箱時間",
    sendRecordCreateTime: "發送記錄時間",
    message66: '綁定谷歌碼',
    cancelScheduleText: "取消定時",
    message67: '轉換額度成功',
    message68: '提現審核中',
    message69: '轉賬憑證不能為空',
    message70: '使用密碼池成功',
    message71: '支付密碼修改成功',
    message72: '用戶名長度為6到20',
    message73: '支付密碼長度為8到20',
    message74: '用戶名不能為中文（包括中文符號）',
    message75: '郵箱不能為中文（包括中文符號）',
    message76: '用戶名長度為6到20',
    message77: "提示：手機掃碼後請輸入谷歌碼及登入密碼，提交成功以完成谷歌綁定！",
    provinceNameText: "歸屬地",
    countryNameText: "國際地區",
    internationalChannelOperatorNameText: "國際營運商",
    submitMessageText: "立即發送",
    cancelMessageText: "取消定時",
    submitByFormText: "我要發送",
    submitByExcelText: "表格提交",
    submitByTemplateText: "模板提交",
    noUseNumberReportText: "沒效號碼導出",
    sendBoxNoUseNumberExcelText: "發件箱沒效號碼.xlsx",
    errorUnauthorized: "授權失敗： 請重新加載頁面以重連服務器。若已試上述方法，請聯絡管理員。",
    errorNetwork: "網絡波動，請重新提交或者重新登錄後進行操作。",
    smsNumbersType: "號碼類型",
    pleaseSelectCostNameText: "請選擇資費名稱",
    pleaseSelectCountryNameText: "請選擇國際地區",
    paySuccess: "支付成功!",
    payFailure: "支付失敗!",
    ifItDidNotRedirect: '如無自動跳轉，請手動關閉瀏覽器'
  },
  monitor: {
    operatorText: "操作人",
    operatorType: "操作者類型",
    operationTimeText: "操作時間",
    operationDescriptionText: "操作描述",
    elapsedTimeText: "耗時",
    operationMethodText: "操作方法",
    methodParameterText: "方法參數",
    IPAddressText: "IP地址",
    operationLocationText: "操作地點",
    createTimeText: "創建時間",
    loginUserText: "登錄用戶",
    loginTimeText: "登錄時間",
    operationText: "操作",
    loginLocationText: "登錄地點",
    loginSystemText: "登錄系統",
    loginBrowserText: "瀏覽器"
  },
  job: {
    content: "內容",
    sendCode: "批次號",
    beanNameText: "Bean名稱",
    methodNameText: "方法名稱",
    statusText: "狀態",
    taskIDText: "任務ID",
    methodParameterText: "方法參數",
    cronExpressionText: "cron表達式",
    remarkText: "備註",
    createTimeText: "創建時間",
    operationText: "操作",
    abnormalInformationText: "異常信息",
    elapsedTimeText: "耗時",
    executedTimeText: "執行時間",
    updateInformationText: "更新信息",
    addJobText: "新增任務",
    updateJobText: "修改任務",
    deleteJobText: "刪除任務",
    batchDeleteJobText: "批量刪除任務",
    pauseJobText: "暫停任務",
    resumeJobText: "恢復任務",
    runJobText: "執行任務",
    exportExcelText: "導出Excel",
    scheduledTaskExcelText: "任務表.xlsx",
    jobOperationText: "任務操作"
  },
  agent: {
    agentNameText: "代理名稱",
    agentIdText: "代理ID",
    channelText: "通道",
    channelNameText: "通道名稱",
    payChannelName: "支付通道",
    payMethod: "支付方式",
    costNameText: "資費名稱",
    channelOperatorText: "通道運營商",
    costParam: "傭金比例",
    costRatio: "傭金參數比例",
    costText: "傭金",
    minimumAmount: "最小額度",
    statusText: "狀態",
    areaNumberText: "地區區號",
    smsTypeText: "短信類型",
    weightingText: "權重",
    numberRandomText: "隨機主叫",
    numberFixationText: "固定主叫",
    descriptionText: "描述",
    remarkText: "備註",
    copyAgentCostText: "復製資費",
    sourceAgentNameText: "代理資費來源",
    targetAgentNameText: "目標代理"
  },
  organization: {
    channelText: "通道",
    channelNameText: "通道名稱",
    costNameText: "資費名稱",
    channelOperatorText: "通道運營商",
    costText: "資費",
    minimumAmount: "最小額度",
    statusText: "狀態",
    areaNumberText: "地區區號",
    smsTypeText: "短信類型",
    weightingText: "權重",
    numberRandomText: "隨機主叫",
    numberFixationText: "固定主叫",
    descriptionText: "描述",
    remarkText: "備註",
    organizationNameText: "企業名稱",
    organizationCodeText: "企業編碼",
    copyOrganizationCostText: "復製資費",
    sourceOrganizationNameText: "企業資費來源",
    targetOrganizationNameText: "目標企業",
    changeAgentText: "轉移代理",
    originAgentNameText: "原代理",
    targetAgentNameText: "目標代理",
    viewOrgDetailText: '對接詳情'
  },
  channel: {
    operatorText: "操作人",
    lastLoginTimeText: "最後使用時間",
    channelIdText: "通道編號",
    channelNameText: "通道名稱",
    protocolTypeText: "協議類型",
    enableChannelText: "通道狀態",
    configurePropertyText: "配置屬性",
    configureCostText: "配置資費",
    testingChannelText: "測試通道",
    numberPoolText: "號碼池",
    updateNumberPoolText: "更新號碼池",
    fixedCallingNumberText: "固定主叫號",
    updateFixedCallingNumberText: "更新固定主叫號",
    connectionStatusText: "連接狀態",
    implementClassText: "實現類",
    waitingSubmitAmountText: "等待發送數量",
    remainingSubmitAmountText: "剩余發送數量",
    failNumberAmountText: "失效號碼數量",
    weightingText: "權重",
    remarkText: "備註",
    creatorText: "創建人",
    channelCodeText: "通道代碼",
    regionRestrictionText: "地區限製",
    operatorRestrictionText: "運營商限製",
    combinedRestrictionText: "組合限製",
    supportRegionText: "支持地區",
    descriptionText: "描述",
    dailyMaximumSubmitAmountText: "每天最大發送量",
    IPAddressText: "ip地址",
    portText: "端口",
    APINumberText: "接口號",
    passwordText: "密碼",
    APITypeText: "接口類型",
    versionText: "版本號",
    codingTypeText: "編碼類型",
    codingSchemeText: "編碼方案",
    connectionNumberText: "連接數",
    speedText: "速率(條/秒)",
    deliveredSpeedText: "分發速率(條/秒)",
    channelPropertyText: "通道屬性(",
    protocolText: "協議)",
    smsTypeText: "短信類型",
    costNameText: "資費名稱",
    costText: "資費",
    channelOperatorText: "通道運營商",
    attributeValueText: "屬性值",
    organizationCodeText: "商戶號",
    gatewayTypeText: "網關類型",
    channelStatusText: "通道狀態",
    settleDayText: "結算日",
    minimumAmountText: "最小金額",
    maximumAmountText: "最大金額",
    requestUrlText: "提交url",
    channelCostText: "通道成本",
    callbackUrlText: "回調url",
    tradeIDText: "交易編碼",
    signatureKeyText: "簽名秘鑰",
    encryptedKeyText: "安全秘鑰",
    groupNameText: "分組名稱",
    addGroupText: "新增分組",
    updateGroupText: "更新分組",
    updateGroupMemberText: "更新分組明細",
    organizationText: "商戶",
    organizationNameText: "企業名稱",
    smsChannelGroupNameText: "通道分組名稱",
    smsChannelGroupStateText: "通道分组狀態",
    configureChannelText: "配置通道",
    addOrganizationCostText: "配置企業資費",
    configureGroupCostText: "配置資費組合",
    configureGroupCostMemberText: "配置企業資費組合",
    forceOperation: '強製執行',
    channelOperationText: "通道操作",
    addChannelText: "新增通道",
    batchDeleteChannelText: "批量刪除通道",
    startChannelText: "啟動通道",
    pauseChannelText: "暫停通道",
    disableChannelText: "停止通道",
    copyChannelCostText: "復製資費",
    sourceChannelNameText: "通道資費來源",
    targetChannelNameText: "目標通道",
    batchUpdateCostText: "批量更新資費",
    batchUpdateAllCostText: "批量更新全部資費",
    payChannelId: "支付通道ID",
    payChannelNameText: "支付通道名稱",
    currencyText: "貨幣",
    netwayCodeText: "支付方法",
    defaultCurrencyText: "默認貨幣",
    minAmountText: "最少充值金額",
    currencyFromText: "轉換前貨幣",
    currencyToText: "轉換後貨幣",
    currencyRateText: "匯率",
    currencyExchangeRateUpdateStateText: "匯率API更新狀態",
    updateTimeText: "更新時間",
    addCurrencyExchangeRateText: "新增貨幣匯率",
    updateCurrencyExchangeRateText: "更新貨幣匯率",
    batchUpdateCurrencyExchangeRateText: "批量更新貨幣匯率",
    createSimilarChannelText: "創建類似通道"
  },
  warningMessage: {
    updateInformationMessage: "請選擇需要修改的記錄",
    selectRecordToDeleteMessage: "請選擇需要刪除的記錄",
    deleteRecordMessage: "刪除記錄",
    deleteRecordConfirmMessage: "確定刪除該記錄？",
    selectPhoneToDeleteMessage: "請選擇需要刪除的手機號碼",
    deletePhoneMessage: "刪除手機號碼",
    deletePhoneConfirmMessage: "確定刪除手機號碼",
    batchDeletePhoneMessage: "批量刪除手機號碼",
    batchDeletePhoneConfirmMessage: "確定批量刪除手機號碼？",
    selectSensitiveWordToDeleteMessage: "請選擇需要刪除的敏感詞",
    deleteSensitiveWordMessage: "刪除敏感詞",
    deleteSensitiveWordConfirmMessage: "確定刪除敏感詞",
    batchDeleteSensitiveWordMessage: "批量刪除敏感詞",
    batchDeleteSensitiveWordConfirmMessage: "確定批量刪除該敏感詞？",
    deleteRecordSuccessMessage: "刪除成功",
    addInformationSuccessMessage: "新增數據成功",
    selectRecordToResubmitMessage: "請選擇需要重發的記錄",
    enterValidParamToResubmitMessage: "請輸入正確搜尋條件",
    resubmitSMSMessage: "確定補發",
    resubmitSMSMessage2: "該短信？",
    resubmitSMSTitle: "補發短信",
    resubmit2RecordTitle: "補發記錄",
    resubmit2RecordRemarkMessage: "確定補發該記錄？",
    selectRecordToResubmitNoticeMessage: "請選擇需要補發通知的記錄",
    resubmitRemarkNoticeTitle: "補發通知回調",
    resubmitRemarkNoticeMessage: "確定補發狀態通知？狀態非【分揀失敗/接收成功/接收失敗】的記錄將不被補發！",
    resubmitRemarkTitle: "重發記錄",
    resubmitRemarkMessage: "確定重發該記錄？狀態非【等待提交/提交失敗】的記錄將不被重發！",
    conditionalUpdateRemarkTitle: "強製執行",
    conditionalUpdateRemarkMessage: "修改發送記錄狀態",
    selectRecordToAuditMessage: "請選擇需要審核的記錄",
    auditRecordMessage: "審核記錄",
    auditRecordConfirmMessage: "確定審核該記錄？",
    refuseReasonConfirmMessage: "輸入拒絕原因，並確認",
    auditSuccessMessage: "審核成功",
    cannotBeEmpty: "不能為空",
    enterChannelNameMessage: "請輸入通道名稱",
    enterChannelCodeMessage: "請輸入通道代碼",
    enterWeightingMessage: "請輸入權重值，數值越高，權重越大",
    enterImplementClassMessage: "請輸入通道實現類",
    enterRegionRestrictionRegexMessage: "請輸入地區限製正則表達式",
    enterOperatorRestrictionRegexMessage: "請輸入運營商限製正則表達式",
    enterCombinedRestrictionRegexMessage: "請輸入地區運營商組合限製正則表達式",
    enterDescriptionMessage: "請輸入描述",
    enterDailySubmitAmountMessage: "請輸入每天發送量",
    pleaseSelectOneChannelMessage: "請選擇一個通道",
    configureChannelPropertyMessage: "請選擇需要配置屬性的通道",
    configureChannelCostMessage: "請選擇需要配置資費的通道",
    updatePropertyMessage: "修改配置屬性",
    updateCostMessage: "修改資費屬性",
    addJobConfirmMessage: "確定新增任務？",
    addJobSuccessMessage: "新增任務成功",
    selectJobToDeleteMessage: "請勾選需要刪除的任務",
    deleteJobConfirmMessage: "確定刪除所選任務？",
    deleteJobSuccessMessage: "刪除任務成功",
    selectJobToPauseMessage: "請勾選需要暫停的任務",
    pauseJobConfirmMessage: "確定暫停所選任務？",
    pauseJobSuccessMessage: "暫停任務成功",
    selectJobToResumeMessage: "請勾選需要恢復的任務",
    resumeJobConfirmMessage: "確定恢復所選任務？",
    resumeJobSuccessMessage: "恢復任務成功",
    selectJobToRunMessage: "請勾選需要執行的任務",
    runJobConfirmMessage: "確定執行所選任務？",
    runJobSuccessMessage: "執行任務成功",
    enterNumberMessage: "請輸入手機號碼或上載號碼文件",
    uploadDynamicVariableDocumentMessage: "請上載號碼文件",
    channelCostExistMessage: "資費已經存在,請勿重新添加",
    selectGroupToUpdateMessage: "請選擇需要更新的分組",
    selectUpdateTemplateMessage: "請選擇需要修改的模板",
    selectMessageToDeleteMessage: "請選擇需要取消定時的短訊",
    cancelScheduleRemarkMessage: "是否立即發送？",
    cancelScheduleRemarkForConfirmMessage: "立即發送: 立即發送【通過審核的】發件箱",
    cancelScheduleRemarkForCancelMessage: "取消定時: 取消定時，不再發送",
    cancelScheduleSuccessMessage: "取消定時成功",
    addSensitiveWordSuccessMessage: "新增敏感詞成功",
    sensitiveWordNoInputMessage: "沒有輸入敏感詞或上載敏感詞文件",
    addPhoneNumberBlackListText: '新增手機黑名單',
    addBlackListSuccessMessage: '新增手機黑名單成功',
    addTemplateSuccessMessage: '新增模板成功',
    importTemplateSuccessMessage: '導入模板成功',
    updateTemplateSuccessMessage: '更新模板成功',
    deleteTemplateMessage: '刪除模板',
    deleteTemplateConfirmMessage: '確定刪除該模板？',
    updateJobSuccessMessage: "更新任務成功",
    deleteGroupMessage: "刪除分組",
    deleteGroupConfirmMessage: "確定刪除該分組？",
    updateGroupMessage: "更新分組",
    updateGroupConfirmMessage: "確定更新該分組?",
    addGroupSuccessMessage: "新增分組成功",
    updateGroupSuccessMessage: "更新分組成功",
    updateGroupDetailSuccessMessage: "更新分組明細成功",
    updateGroupStatusSuccessMessage: "更新分組狀態成功",
    selectChannelToDeleteMessage: "請選擇需要刪除的通道",
    deleteChannelMessage: "刪除通道",
    deleteChannelConfirmMessage: "確定刪除該通道？",
    selectChannelToStartMessage: "請選擇需要啟動的通道",
    startChannelMessage: "啟動通道",
    startChannelConfirmMessage: "確定啟動該通道？",
    startChannelSuccessMessage: "啟動通道成功",
    selectChannelToPauseMessage: "請選擇需要暫停的通道",
    pauseChannelMessage: "暫停通道",
    pauseChannelConfirmMessage: "確定暫停該通道？",
    pauseChannelSuccessMessage: "暫停通道成功",
    selectChannelToDisableMessage: "請選擇需要停止的通道",
    disableChannelMessage: "停止通道",
    disableChannelConfirmMessage: "確定停止該通道？",
    disableChannelSuccessMessage: "停止通道成功",
    addChannelSuccessMessage: "新增通道成功",
    updateChannelSuccessMessage: "更新通道成功",
    deleteChannelSuccessMessage: "刪除通道成功",
    addChannelPropertySuccessMessage: "新增通道屬性成功",
    updateChannelPropertySuccessMessage: "更新通道屬性成功",
    updateNumberPoolSuccessMessage: "更新號碼池成功",
    updateNumberFixationSuccessMessage: "更新固定主叫號成功",
    addChannelCostSuccessMessage: "新增通道資費成功",
    updateChannelCostSuccessMessage: "更新通道資費成功",
    deleteChannelCostMessage: "刪除通道資費",
    deleteChannelCostConfirmMessage: "確定刪除該通道資費？",
    addPayChannelSuccessMessage: "新增支付通道成功",
    updatePayChannelSuccessMessage: "更新支付通道成功",
    selectPayChannelToDeleteMessage: "請選擇需要刪除的支付通道",
    selectPayChannelToCopy: "請選擇需要一个複製的支付通道",
    deletePayChannelMessage: "刪除支付通道",
    deletePayChannelConfirmMessage: "確定刪除該支付通道？",
    deletePayChannelSuccessMessage: "刪除支付通道成功",
    submitSMSMessage: "發送短信",
    submitSMSConfirmMessage: "確定發送該短信？",
    submitScheduledSMSMessage: "發送定時短信",
    submitScheduledSMSConfirmMessage: "確定發送該定時短信？",
    fileExceedMessage: "上傳文件超過上限",
    fileExceedLimitMessage: "文件數量上限是",
    fileSizeExceedMessage: "上傳文件大小超過上限",
    fileSizeExceedLimitMessage: "文件大小上限是",
    submitSMSSuccessMessage: "成功發送短信",
    submitScheduledSMSSuccessMessage: "成功發送定時短信",
    uploadInvalidFileFormatMessage: "上傳文件格式不合符要求，請重新上傳",
    forceLogoffMessage: "強製登出用戶",
    forceLogoffConfirmMessage: "確定強製登出該用戶？",
    forceLogoffSuccessMessage: "強製登出用戶成功",
    removeGoogleMessage: "解綁用戶google二維碼",
    removeGoogleConfirmMessage: "確定解綁該用戶google二維碼？",
    removeGoogleSuccessMessage: "解綁google二維碼成功",
    selectUserToUpdatePermissionMessage: "請選擇需要更新的用戶",
    updatePermissionMessage: "更新用戶權限",
    updatePermissionConfirmMessage: "確定更新該用戶權限？",
    updatePermissionSuccessMessage: "更新用戶權限成功",
    batchUpdatePermissionMessage: "批量更新用戶權限",
    batchUpdatePermissionConfirmMessage: "確定批量更新該用戶權限？",
    batchUpdatePermissionSuccessMessage: "批量更新用戶權限成功",
    selectBlackListToDeleteMessage: "請選擇需要刪除的黑名單",
    deleteBlackListMessage: "刪除黑名單",
    deleteBlackListConfirmMessage: "確定刪除該黑名單",
    deleteBlackListSuccessMessage: "刪除黑名單成功",
    passwordFormatNoUpperMessage: "密碼須有最少一個大階英文字母",
    batchCancelAgentConfirmMessage: "確認批量作廢代理？",
    cancelAgentCancelledMessage: "作廢代理已取消",
    cancelAgentSuccessMessage: "作廢代理成功!",
    cancelOrganizationConfirmMessage: "確認作廢企業？",
    cancelOrganizationConfirmRemarkMessage: "該企業附屬所有企業用戶皆會作廢。",
    batchCancelOrganizationConfirmMessage: "確認批量作廢企業？",
    batchCancelOrganizationConfirmRemarkMessage: "所選企業附屬所有企業用戶皆會作廢。",
    cancelOrganizationCancelledMessage: "作廢企業已取消",
    cancelOrganizationSuccessMessage: "作廢代理成功!",
    cancelOrganizationRemarkMessage: "批量操作默認不處理剩余可用金額。",
    cancelOrganizationRemarkMessage1: "如需要轉移可用金額於對應代理，請單次處理作廢企業。",
    deleteAgentSystemConfigMessage: "刪除代理配置",
    deleteAgentSystemConfigConfirmMessage: "確定刪除代理配置",
    deleteAgentSystemConfigSuccessMessage: "刪除代理配置成功",
    selectTemplateToSubmitMessage: "請選擇需要發送短信的模板",
    pleaseSelectOneTemplateMessage: "請選擇一個模板",
    pleaseSelectValidTemplateMessage: "請選擇審核狀態為審核通過的模板",
    pleaseEnterBatchNumberMessage: "請輸入批次號",
    pleaseSelectLatestSevenDaysMessage: "請選擇最近7天",
    selectExcelToDownloadMessage: "請選擇需要下載的報表",
    pleaseWaitForExportMessage: "已接受指令，正在處理數據，導出需時，請耐心等侯。(導出50W條數據約需1分鐘。)",
    pleaseWaitForExportAndNavigateMessage: "已接受指令，正在處理數據，報表可於 '報表管理/導出報表' 下載。 (生成50W條數據約需50秒。)",
    pleaseWaitForExportAndNavigateTitle: "導出報表提示",
    exportAndNavigateConfirmButtonText: "前往",
    exportAndNavigateCancelButtonText: "已讀",
    selectExcelToDeleteMessage: "請選擇需要刪除的報表",
    deleteExcelMessage: "刪除報表",
    deleteExcelConfirmMessage: "確定刪除報表",
    batchDeleteExcelMessage: "批量刪除報表",
    batchDeleteExcelConfirmMessage: "確定批量刪除該報表？",
    excelFormatRemarkMessage1: "xls格式行數上限為65536, 支援 MS 2003 Excel 或之前版本 ",
    excelFormatRemarkMessage2: "xlsx格式行數上限為1048576, 不支援 MS 2003 Excel 或之前版本 ",
    excelFormatRemarkMessage3: "默認為xlsx格式及行數50W",
    invalidRowLimitMessage: "錯誤報表行數",
    currentExcelSettingMessage: "現在使用的報表配置:",
    defaultExcelSettingMessage: "默認配置",
    addExcelSettingSuccessMessage: "添加報表配置成功",
    addExcelSettingFailMessage: "添加報表配置失敗",
    pleaseWaitForProcessMessage: "已接受指令，正在處理，請耐心等侯。",
    pleaseWaitForProcessSendBoxSubmitMessage: " 後臺正在處理，請稍等！註意查看發件箱！",
    pleaseWaitForPreviewContentMessage: "正在準備預覽內容，請耐心等候。",
    channelGroupAddMemberRemark: "一個企業只可以加入一個分組。加入分組時，會刪除該企業全部資費。如果企業已加入其他分組，會刪除前分組的資費。資費組合狀態和權重會跟隨對應通道。",
    channelGroupDeleteMemberRemark: "刪除企業時，該企業在該分組中所有資費都會被刪除。",
    channelGroupAddChannelRemark: "分組可以加任意通道，在該分組中所有企業都會增加新通道的資費。",
    channelGroupDeleteChannelRemark: "刪除通道時，在該分組中所有企業都會刪除對應通道的資費。",
    channelGroupDeleteGroupRemark: "刪除分組時，所有該分組中所有企業的資費都會被刪除。",
    channelGroupAddCostRemark: "分組可以加任意資費組合，在該分組中所有企業都會增加新資費組合。資費組合狀態和權重會跟隨對應通道。",
    channelGroupAddCostMemberRemark: "一個企業只可以加入一個分組。加入分組時，會刪除該企業全部資費。如果企業已加入其他分組，會刪除前分組的資費。",
    channelGroupDeleteCostRemark: "刪除資費組合時，在該分組中所有企業都會刪除對應資費組合。",
    channelGroupDeleteCostMemberRemark: "刪除企業時，該企業會刪除在該分組中所有的資費組合。亦不會刪除分組以外的資費。",
    selectChannelGroupMemberMessage: "請選擇企業資費",
    selectChannelGroupCostMessage: "請選擇資費組合",
    pleaseSelectSourceOrganizationAndTargetOrganizationMessage: "請選擇企業資費來源和目標企業",
    copyOrganizationCostSuccessMessage: "復製企業資費成功!",
    copyOrganizationCostRemark: "復製資費時，所有目標企業的資費都會被刪除。",
    pleaseSelectTargetOrganizationAndTargetAgentMessage: "請選擇目標企業和目標代理",
    changeAgentSuccessMessage: "轉移代理成功!",
    changeAgentRemark: "轉移代理時，所有目標企業的資費都會被刪除。如目標企業已加入通道分組，會強製退出通道分組。",
    pleaseSelectSourceAgentAndTargetAgentMessage: "請選擇代理資費來源和目標代理",
    copyAgentCostSuccessMessage: "復製代理資費成功!",
    copyAgentCostRemark: "復製資費時，所有目標代理的資費都會被刪除。",
    pleaseSelectSourceChannelAndTargetChannelMessage: "請選擇通道資費來源和目標通道",
    copyChannelCostSuccessMessage: "復製通道資費成功!",
    copyChannelCostRemark: "復製資費時，所有目標通道的資費都會被刪除。",
    updateTemplateRemarkTitle: "更新模板",
    updateTemplateRemarkMessage: "模板發送用戶更新模板內容時，模板審核狀態會設置為待審核",
    selectOrganizationMessage: "請選擇企業",
    selectOneOrganizationMessage: "請選擇一位企業",
    HTTPAndSMPPNotAvailableMessage: "未開通SMPP或HTTP接口",
    addCurrencyExchangeRateSuccessMessage: "新增貨幣匯率成功",
    updateCurrencyExchangeRateSuccessMessage: "更改貨幣匯率成功",
    selectCurrencyExchangeRateToUpdateMessage: "請選擇需即時更新的貨幣匯率",
    updateCurrencyExchangeRateTitle: "即時更新貨幣匯率",
    updateCurrencyExchangeRateMessage: "確定即時更新貨幣匯率？所有已選的貨幣匯率都會即時更新，包括更新狀態為手動更新的貨幣匯率!"
  },
  auditOptionsText: {
    waitForAuditText: "待審核",
    auditVerifiedText: "審核通過",
    auditNotVerifiedText: "審核不通過",
    manualAuditText: "人工審核"
  },
  informationOptionsText: {
    smsMessageText: "短信"
  },
  statusOptionsText: {
    normalText: "正常",
    pauseText: "暫停",
    sortingFailText: "分揀失敗",
    waitingSubmitUpstreamText: "等待提交",
    submitSuccessText: "提交成功",
    submitFailText: "提交失敗",
    receiveSuccessText: "接收成功",
    receiveFailText: "接收失敗"
  },
  submitMethodOptionText: {
    backendSubmitText: "商戶後臺",
    httpSubmitText: "http接口",
    smppSubmitText: "smpp接口"
  },
  submitNumberMethodOptionText: {
    submitByFormText: "普通表單提交",
    submitByExcelTemplateText: "excel模板提交"
  },
  numberRegionOptionsText: {
    china: "國內",
    hongKong: "香港",
    international: "國際"
  },
  smsChannelNameOptionText: {
    httpProtocolText: "http協議",
    smppProtocolText: "smpp協議"
  },
  smsChannelStatusOptionText: {
    enableText: "啟動",
    pauseText: "暫停",
    disableText: "停止"
  },
  smsChannelConnectionStatusOptionText: {
    connectionSuccessText: "已連接",
    connectionFailText: "未連接"
  },
  forceBindGoogleOptionText: {
    freeText: "非強製綁定",
    forceText: "強製綁定"
  },
  storedGoogleStatusOptionText: {
    noneText: "未綁定",
    storedText: "已綁定"
  },
  checkNumberCountOptionText: {
    noAuditText: "不需審核",
    auditText: "需要審核"
  },
  activeUserOptionText: {
    activeText: "活躍用戶",
    inactiveText: "非活躍用戶"
  },
  booleanStateOptionText: {
    noText: "否",
    yesText: "是"
  },
  googleCodeRemarkMessage: {
    googleCodeRemarkTitle: "綁定谷歌驗證碼提醒",
    googleCodeRemarkMessage: "請綁定谷歌驗證碼，下次登錄必須使用谷歌驗證碼。",
    confirmButtonText: "立即綁定",
    cancelButtonText: "已讀"
  },
  serverNotRespond: {
    serverNotRespondTitle: "",
    serverNotRespondMessage: "服務器沒有響應，將重定向到登錄頁面",
    confirmButtonText: "重新登入"
  },
  loginBlackList: {
    roleText: "身份",
    agentText: "代理",
    agentNameText: "代理名稱",
    organizationUserText: "企業用戶",
    organizationUserNameText: "企業用戶名稱"
  },
  exportedExcel: {
    userNameText: "用戶名",
    roleText: "身份",
    serviceNameText: "應用名稱",
    fileNameText: "文件名稱",
    statusText: "狀態",
    remarkText: "備註",
    creatorText: "創建人",
    createTimeText: "創建日期",
    updateExportedExcelTitle: "更新報表備註",
    downloadText: "下載",
    batchDownloadText: "批量下載"
  },
  exportedExcelServiceName: {
    sendBoxNoUseNumber: "沒效號碼報表",
    sendBox: "發件箱",
    sendRecord: "發送記錄",
    returnRecord: "回執記錄",
    sendBoxHistory: "歷史發件箱",
    sendRecordHistory: "歷史發送記錄",
    returnRecordHistory: "歷史回執記錄",
    statisticalAgent: "代理日報表",
    statisticalMonAgent: "代理月報表",
    statisticalChannel: "通道日報表",
    statisticalMonChannel: "通道月報表",
    statisticalChannelOperator: "通道運營商日報表",
    statisticalMonChannelOperator: "通道運營商月報表",
    statisticalConsumeAmount: "資費詳情日報表",
    statisticalMonConsumeAmount: "資費詳情月報表",
    statisticalOrgCode: "企業日報表",
    statisticalMonOrgCode: "企業月報表",
    statisticalGeneral: "綜合日報表",
    statisticalRateSuccess: "批次成功率",
    statisticalTotalDaily: "總日報",
    statisticalAllConsumeAmount: "全部資費日報表",
    statisticalMonAllConsumeAmount: "全部資費月報表",
    MSGID: "MSGID",
    sortingFail: "分揀失敗報表"
  },
  placeholder: {
    verificationCode: "請輸入谷歌驗證碼"
  },
  roleOptionsText: {
    adminText: "管理員",
    agentText: "代理",
    organizationText: "企業"
  },
  excelStatusOptionsText: {
    availableText: "可下載",
    unavailableText: "鎖定"
  },
  excelFormatOptionText: {
    xls: "xls",
    xlsx: "xlsx"
  },
  smsNumberTypeOptionText: {
    formSubmitText: "普通表單提交",
    excelSubmitText: "excel模板提交"
  },
  numberAreaProvince: {
    BeiJing: "北京",
    Tianjin: "天津",
    HeBei: "河北",
    LiaoNing: "遼寧",
    JiLin: "吉林",
    HeiLongJiang: "黑龍江",
    ShanDong: "山東",
    JiangSu: "江蘇",
    ShangHai: "上海",
    ZheJiang: "浙江",
    AnHui: "安徽",
    FuJian: "福建",
    JiangXi: "江西",
    GuangDong: "廣東",
    GuangXi: "廣西",
    HaiNan: "海南",
    HeNan: "河南",
    HuNan: "湖南",
    HuBei: "湖北",
    ShanXi: "山西",
    NeiMengGu: "內蒙古",
    NingXia: "寧夏",
    QingHai: "青海",
    ShanXiS: "陜西",
    GanSu: "甘肅",
    XinJiang: "新疆",
    SiChuan: "四川",
    GuiZhou: "貴州",
    YunNan: "雲南",
    ChongQing: "重慶",
    XiZang: "西藏"
  },
  smsNumberArea: {
    UnitedStates: "美國",
    Canada: "加拿大",
    CanadaAndUnitedStates: "加拿大/美國",
    China: "中國內地",
    HongKong: "香港",
    Macao: "澳門",
    Taiwan: "臺灣",
    Malaysia: "馬來西亞",
    Indonesia: "印度尼西亞",
    Philippines: "菲律賓",
    Singapore: "新加坡",
    Thailand: "泰國",
    Brunei: "文萊",
    Japan: "日本",
    SKorea: "韓國",
    Vietnam: "越南",
    NKorea: "朝鮮",
    Cambodia: "柬埔寨",
    Laos: "老撾",
    Bangladesh: "孟加拉國",
    Turkey: "土耳其",
    India: "印度",
    Pakistan: "巴基斯坦",
    Afghanistan: "阿富汗",
    SriLanka: "斯裏蘭卡",
    Myanmar: "緬甸",
    Maldives: "馬爾代夫",
    Lebanon: "黎巴嫩",
    Jordan: "約旦",
    Syria: "敘利亞",
    Iraq: "伊拉克",
    Kuwait: "科威特",
    SaudiArabia: "沙特阿拉伯",
    Oman: "阿曼",
    Israel: "以色列",
    Bahrain: "巴林",
    Qatar: "卡塔爾",
    Bhutan: "不丹",
    Mongolia: "蒙古",
    Nepal: "尼泊爾",
    Iran: "伊朗",
    Russia: "俄羅斯",
    Greece: "希臘",
    Netherlands: "荷蘭",
    Belgium: "比利時",
    France: "法國",
    Spain: "西班牙",
    Gibraltar: "直布羅陀",
    Portugal: "葡萄牙",
    Luxembourg: "盧森堡",
    Ireland: "愛爾蘭",
    Iceland: "冰島",
    Albania: "阿爾巴尼亞",
    Malta: "馬耳他",
    Cyprus: "塞浦路斯",
    Finland: "芬蘭",
    Bulgaria: "保加利亞",
    Hungary: "匈牙利",
    Germany: "德國",
    Yugoslavia: "南斯拉夫",
    Italy: "意大利",
    SanMarino: "聖馬力諾",
    Vatican: "梵蒂岡",
    Romania: "羅馬尼亞",
    Switzerland: "瑞士",
    Liechtenstein: "列支敦士登",
    Austria: "奧地利",
    UnitedKingdom: "英國",
    Denmark: "丹麥",
    Sweden: "瑞典",
    Norway: "挪威",
    Poland: "波蘭",
    Egypt: "埃及",
    Morocco: "摩洛哥",
    Algeria: "阿爾及利亞",
    Tunisia: "突尼斯",
    Libya: "利比亞",
    Gambia: "岡比亞",
    Senegal: "塞內加爾",
    Mauritania: "毛裏塔尼亞",
    Mali: "馬裏",
    Guinea: "幾內亞",
    CotedIvoire: "科特迪瓦",
    BurkinaFaso: "布基拉法索",
    Niger: "尼日爾",
    Togo: "多哥",
    Benin: "貝寧",
    Mauritius: "毛裏求斯",
    Liberia: "利比裏亞",
    SierraLeone: "塞拉利昂",
    Ghana: "加納",
    Nigeria: "尼日利亞",
    Chad: "乍得",
    CentralAfrica: "中非",
    Cameroon: "喀麥隆",
    CapeVerde: "佛得角",
    SaoTome: "聖多美",
    Principe: "普林西比",
    SaoTomeAndPrincipe: "聖多美和普林西比",
    EquatorialGuinea: "赤道幾內亞",
    Gabon: "加蓬",
    Congo: "剛果",
    Zaire: "紮伊爾",
    Angola: "安哥拉",
    GuineaBissau: "幾內亞比紹",
    Ascension: "阿森松",
    Seychelles: "塞舌爾",
    Sudan: "蘇丹",
    Rwanda: "盧旺達",
    Ethiopia: "埃塞俄比亞",
    Somalia: "索馬裏",
    Djibouti: "吉布提",
    Kenya: "肯尼亞",
    Tanzania: "坦桑尼亞",
    Uganda: "烏幹達",
    Burundi: "布隆迪",
    Mozambique: "莫桑比克",
    Zambia: "贊比亞",
    Madagascar: "馬達加斯加",
    Reunion: "留尼旺島",
    Zimbabwe: "津巴布韋",
    Namibia: "納米比亞",
    Malawi: "馬拉維",
    Lesotho: "萊索托",
    Botswana: "博茨瓦納",
    Swaziland: "斯威士蘭",
    Comoros: "科摩羅",
    SouthAfrica: "南非",
    StHelena: "聖赫勒拿",
    Aruba: "阿魯巴島",
    FaroeIslands: "法羅群島",
    Midwayisland: "中途島",
    Hawaii: "夏威夷",
    WakeIsland: "威克島",
    Anguilla: "安圭拉島",
    TheVirginIslands: "維爾京群島",
    SaintLucia: "聖盧西亞",
    PuertoRico: "波多黎各",
    Jamaica: "牙買加",
    Bahamas: "巴哈馬",
    Barbados: "巴巴多斯",
    Alaska: "阿拉斯加",
    Greenland: "格陵蘭島",
    Belize: "伯利茲",
    Guatemala: "危地馬拉",
    Salvador: "薩爾瓦多",
    Honduras: "洪都拉斯",
    Nicaragua: "尼加拉瓜",
    CostaRica: "哥斯達黎加",
    Panama: "巴拿馬",
    Haiti: "海地",
    Peru: "秘魯",
    Mexico: "墨西哥",
    Cuba: "古巴",
    Argentina: "阿根廷",
    Brazil: "巴西",
    Chile: "智利",
    Colombia: "哥倫比亞",
    Venezuela: "委內瑞拉",
    Bolivia: "玻利維亞",
    Guyana: "圭亞那",
    Ecuador: "厄瓜多爾",
    FrenchGuiana: "法屬圭亞那",
    Paraguay: "巴拉圭",
    Martinique: "馬提尼克",
    Suriname: "蘇裏南",
    Uruguay: "烏拉圭",
    Australia: "澳大利亞",
    NewZealand: "新西蘭",
    Guam: "關島",
    CocosIsland: "科科斯島",
    NorfolkIsland: "諾福克島",
    Christmasisland: "聖誕島",
    Nauru: "瑙魯",
    Tonga: "湯加",
    SolomonIslands: "所羅門群島",
    Vanuatu: "瓦努阿圖",
    Fiji: "斐濟",
    CorkIslands: "科克群島",
    Niue: "紐埃島",
    EasternSamoa: "東薩摩亞",
    WesternSamoa: "西薩摩亞",
    Kiribati: "基裏巴斯",
    Tuvalu: "圖瓦盧",
    AntiguaAndBarbuda: "安地卡及巴布達",
    BritishVirginIslands: "英屬維爾京群島",
    USVirginIslands: "美屬維京群島",
    CaymanIslands: "開曼群島",
    Bermuda: "百慕大",
    Grenada: "格瑞那達",
    TurksAndCaicosIslands: "特克斯和凱科斯群島",
    Montserrat: "蒙哲臘",
    AmericanSamoa: "美屬薩摩亞",
    StMaarten: "荷屬聖馬丁",
    StLucia: "聖露西亞",
    Dominica: "多米尼克",
    StVincentAndGrenadines: "聖文森及格瑞那丁",
    DominicanRepublic: "多米尼加共和國",
    TrinidadAndTobago: "特立尼達和多巴哥",
    StKittsAndNevis: "聖克裏斯多福及尼維斯",
    SouthSudan: "南蘇丹",
    DiegoGarcia: "英屬印度洋領地",
    Eritrea: "厄立特裏亞",
    Lithuania: "立陶宛",
    Latvia: "拉脫維亞",
    Estonia: "愛沙尼亞",
    Moldova: "摩爾多瓦",
    Armenia: "亞美尼亞",
    Belarus: "白俄羅斯",
    Andorra: "安道爾",
    Monaco: "摩納哥",
    Ukraine: "烏克蘭",
    Serbia: "塞爾維亞",
    Montenegro: "黑山",
    Kosovo: "科索沃",
    Croatia: "克羅地亞",
    Slovenia: "斯洛文尼亞",
    BosniaAndHerzegovina: "波斯尼亞和黑塞哥維那",
    Macedonia: "馬其頓",
    CzechRepublic: "捷克",
    Slovakia: "斯洛伐克",
    Yemen: "也門",
    Palestine: "巴勒斯坦",
    UAE: "阿聯酋",
    Tajikistan: "塔吉克斯坦",
    Turkmenistan: "土庫曼斯坦",
    Azerbaijan: "阿塞拜疆",
    Georgia: "格魯吉亞",
    Kyrgyzstan: "吉爾吉斯斯坦",
    Uzbekistan: "烏茲別克斯坦",
    EastTimor: "東帝汶",
    PapuaNewGuinea: "巴布亞新幾內亞",
    Palau: "帕勞",
    WallisFutuna: "瓦利斯和富圖那",
    NewCaledonia: "新喀裏多尼亞",
    FrenchPolynesia: "法屬波利尼西亞",
    Tokelau: "托克勞",
    Micronesia: "密克羅尼西亞",
    MarshallIslands: "馬紹爾群島",
    Inmarsat: "國際海事衛星組織",
    FalklandIslands: "福克蘭群島",
    StPierreAndMiquelon: "聖皮埃爾和密克隆群島",
    Guadeloupe: "瓜德羅普島"
  },
  rechargeState: {
    orderState: '訂單狀態',
    createFail: '創建失敗',
    createSuccess: '創建成功',
    submitFail: '提交失敗',
    submitSuccess: '提交成功',
    notifyFail: '回調失敗',
    notifySuccess: '回調成功',
    refund: '退款',
    credited: '已入帳'
  },
  refundOrder: {
    orderState: '訂單狀態',
    rechargeOrderNumber: '充值訂單編號',
    refundAmountText: "退款金額",
    refundReasonText: "退款原因",
    netWayCodeText: "充值類型"
  },
  rechargeNotify: {
    notifyTypeText: '回執類型'
  },
  refundOrderState: {
    receiveSuccess: '接收成功',
    receiveFail: '接收失敗',
    submitSuccess: '提交上游成功',
    submitFail: '提交上游失敗',
    refundSuccess: '退款成功',
    refundFail: '退款失敗'
  },
  currencyExchangeRateUpdateState: {
    apiUpdateText: 'API 更新',
    manualUpdateText: '手動更新'
  },
  notifyType: {
    rechargeOrderNotifyText: '支付回執',
    refundOrderNotifyText: '退款回執'
  },
  agentRemitOrder: {
    accountNo: '賬號/電話',
    bank: '銀行',
    alipay: '支付寶',
    weChat: '微信',
    accountName: '账号名稱',
    rejectReason: '拒絕原因',
    withdrawCurrency: '提現貨幣類型',
    amountAfterConversion: '轉換後金額',
    amountAfterConversionForTable: '對應貨幣提現金額',
    rate: '匯率',
    accountDetail: '賬號詳情'
  },
  agentAmountChangeRecord: {
    reasonForChangeInAmount: '金額改動原因',
    effectiveAmountBeforeOperation: '操作前有效金額',
    changeEffectiveAmount: '變動有效金額',
    effectiveAmountAfterOperation: '操作後有效金額',
    amountToBeCreditedBeforeOperation: '操作前待入賬金額',
    changesToTheAmountToBeRecorded: '變動待入賬金額',
    amountToBeCreditedAfterOperation: '操作後待入賬金額'
  },
  rechargeOrderNotify: {
    getRequestSent: '已發送獲取請求'
  },
  rechargeOrderRecord: {
    channelName: '通道名稱',
    channelID: '通道ID'
  }
};
exports.default = _default;